//AJAX 프레임
import { ajaxFrame } from '../lib/ajaxForm';
//로딩 액션
import { AjaxLoading } from '../../../actions/Interactions/loading';
//데이터 API 목록
import { dataUrl } from '../dataUrl';
//import datePicker
import '../../../lib/jquery.daterangepicker.min';
//UI라이브러리
import '../../../actions/ui/datePicker';

//데이터 저장용
var faListData = {}; //즐겨찾기 전체 리스트
var keywordData = {}; // 키워드 데이터
var addKeywordData = {}; //추가 키워드 리스트
var groupKeyword = {}; //그룹 키워드advSubId
var pushKeywordData = {}; //키워드 추가 데이터
var newKeywordData = {}; //신규 키워드
var moveKeywordData = {}; // 이동 키워드
var modifyKeywordData = {}; // 일괄변경 키워드 데이터
var bidSetSaveKeywordData = {}; //입찰가 일괄설정
var bidCpaSaveKeywordData = {}; //CPA 일괄설정
var bidOppSaveKeywordData = {};
var statusKwd = {}; // 상태 키워드
var statusData = {}; // 상태 데이터
var tableFilterData = {}; // 테이블 제어 데이터
var filterCheckSave = {}; //제어 체크 데이터
var bidChangeList = {}; //입찰가 일괄변경 리스트
var bidSetList = {}; //일괄설정 리스트
var naverSaveAPIData = {};
var bidScheAllData = {}; //전체 예약 설정 데이터

const AMT_MAX_VALUE = 100000;
var OPTION_MAX_BID_AMT = AMT_MAX_VALUE;


//히든값 엘리먼트
var groupId = '#advId';
var groupNm = '#advNm';
var groupKey = '#advKey';
var groupSubId = "#adgKey";


//히든값 빈 변수
var advNm;
var advKey;
var advId;

//NULL 값
var searchData = null;
var advSubId = null;
var historyKey = null;
var clickedSingleKwdId = null;
var bidSetChange = null;
var thisKey = null;
var bidScheAllClickKwd = null;

//서브 체크
var subCheck = false;
var chartDataCheck = false;




export const favoriteFunc = {
	init:function() {
	},


	//Data or PopUpFunction (Start)
	//즐겨찾기 리스트
	//즐겨찾기 서브 리스트
	favoriteSubListData:function(dataId, type) {
		advId = $(groupId).val();
		advNm = $(groupNm).val();
		advKey = $(groupKey).val();
		$('.check-btn').prop('disabled',true);
		advSubId = $(groupSubId).val();
		searchData = null;
		subCheck = true;
		if(dataId !== undefined) {
			var dataApi = dataUrl.favoriteAPI('GET', 'subList', dataId);
			if(type != 'sync') {
				AjaxLoading.pageLoading();
			}
			$('.main_search_wrap, .bidding_function_wrap').show();
			$('#all_check').prop('checked',false);
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
		}else{
			$('.main_search_wrap, .bidding_function_wrap').hide();
			$('.none_date p').text('즐겨찾기 그룹이 없습니다.');
			$('.favorite_table_wrap').hide();
			$('.favorite_none_wrap').show();
		}
	},

	favoriteResultDivOnScroll : function(){
		var $list1 = $('.table_01');
		var leftOffset = $('.table_scroll_xy').scrollLeft();
		$list1.css('left', leftOffset);
	},

	//즐겨찾기 검색
	favoriteSearchData:function(data) {
		var favoriteId = null;
		searchData = data;
		$('.menu-sub-category .menu-sub-inner li').each(function() {
			var $this = $(this);
			var subActiveCheck = $this.find('a').hasClass('active');
			if(subActiveCheck == true) {
				favoriteId = $this.find('a').attr('data-id');
			}
		});
		if(favoriteId != null) {
			subCheck = true;
			var param = "?bid_favorite_id=" + favoriteId + "&" + searchData;
			var dataApi = dataUrl.favoriteAPI('GET','search', param);
			AjaxLoading.pageLoading();
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
		}
	},


	//즐겨찾기 등록 키워드
	favoriteGroupKeywordData:function(data) {
		var param =  "?adv_id=" + advId;
		var dataApi = dataUrl.favoriteAPI('GET','groupKey', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteGroupKeywordCallBack);
	},


	//즐겨찾기 키워드 팝업
	favoriteKeywordPopUp:function(obj, data) {
		favoriteFunc.favoriteKeywordPopCallBack();
	},


	//즐겨찾기 운영키워드 검색
	favoriteKeywordSearchData:function(data) {
		var param = "?adv_id=" + advId + "&" + data;
		var dataApi = dataUrl.favoriteAPI('GET','masterSearch', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteKeywordCallBack);
	},


	//즐겨찾기 신규 키워드 리스트
	favoriteAddKeywordListData:function(data) {
		if(data != '') {
			var param = '?na_customer=' + data;
			var dataApi = dataUrl.favoriteAPI('GET','keywordAddList-1', param);
			AjaxLoading.pageLoading();
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordListCallBack);
		}
	},


	//즐겨찾기 신규 키워드 리스트2
	favoriteAddKeywordListData2:function(dataEl) {
		var thisId = $(dataEl).attr('data-id');
		var param = '?na_customer=' + advKey + '&na_campaign_ser=' + thisId;
		var dataApi = dataUrl.favoriteAPI('GET','keywordAddList-2', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordList2CallBack);
	},


	//즐겨찾기 신규 키워드 리스트3
	favoriteAddKeywordListData3:function(dataEl) {
		var thisId = $(dataEl).attr('data-id');
		var param = '?na_customer=' + advKey + '&na_adgroup_ser=' + thisId;
		var dataApi = dataUrl.favoriteAPI('GET','keywordAddList-3', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteAddKeywordList3CallBack);
	},


	//즐겨찾기 키워드 등록
	favoriteAddKeywordPushData:function(type) {
		if(type == 'add') {
			var pushSubId = advSubId;
			var pushKey = Object.keys(pushKeywordData);
			var pushValue = pushKey.map(function(key) {
				return pushKeywordData[key];
			});
		}else if(type == 'move') {
			var pushSubId = $('#move-group-select').val();
			if(pushSubId != '') {
				var pushKey = Object.keys(moveKeywordData);
				var pushValue = pushKey.map(function(key) {
					return moveKeywordData[key];
				});
				alert('키워드가 이동되었습니다.');
			}else{
				alert('이동할 그룹을 선택해주세요.');
				return;
			}
		}
		if(pushSubId != undefined) {
			var request = { "group" :
				{
					"id" : Number(pushSubId),
					"advs_id" : Number(advId)
				},
				"keywords" : pushValue
			}
		}else{
			var request = { "group" :
				{
					"advs_id" : Number(advId)
				},
				"keywords" : pushValue
			};
		}
		if(0 < pushValue.length) {
			var dataApi = dataUrl.favoriteAPI('POST','keywordPush');
			ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, favoriteFunc.favoriteKeywordPushCallBack, request);
		}else{
			alert('키워드 선택 후 이용해주세요.');
		}
	},


	//오름차순/내림차순 (현재순위, 목표순위, 현재입찰가, 최대입찰가)
	favoriteSortChangeData:function(sort, type, thisEl) {
		var searchKey = '';
		var $this = $(thisEl);
		if(advSubId != null) {
			searchKey = 'bid_favorite_id=' + advSubId;
			if(searchData != null) {
				searchKey += '&' + searchData;
			}
		}else{
			searchKey = 'adv_id=' + advId;
		}
		if(sort == 'BASIC') {
			var param = '?' + searchKey;
		}else{
			var param = '?' + searchKey + '&sort=' + sort + '&sort_field=' + type;
		}
		//action
		$this.parents('ul').find('button').removeClass('on');
		$this.addClass('on');
		AjaxLoading.pageLoading();
		var dataApi = dataUrl.favoriteAPI('GET','sort', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
	},


	//순위/입찰가 작업 - 목표순위 변경 / 현재 입찰가 변경/ 입찰유형 변경/ 최대 입찰가 변경/ 목표순위,최대입찰가 일괄 변경 /경쟁사순위변경
	favoriteBidChangeData:function(thisEl, allType, condition) {
		var $this = $(thisEl);
		var type = $this.attr('data-type');
		var keyId = $this.parents('tr').attr('data-id');
		var keywords = faListData[keyId];
		var listArray = [];
		var changeKey = [];
		var updateData;
		var ajaxType = 'PUT';
		var updateType = '';
		var multi = false;
		var subEl = '.favorite_inner_table_wrap tbody tr, #bid_amt_preview_table tbody tr';
		var $bidListTr = $('#bid-list-body-2 tr');
		if(type == 'bidRank') {
			if(confirm("변경 하시겠습니까?") == true) {
				//순위변경
				ajaxType = 'PUT';
				updateType = 'type3';
				var key = $this.attr('data-name');
				var value = $this.val();
				$this.addClass('effect');
				setTimeout(function() {
					$this.removeClass('effect');
				}, 500);
				changeKey.push(key);
				keywords['before_goal_rank'] = keywords[key];
				keywords[key] = value;
				$this.attr('data-rank', value);
				listArray.push(keywords);
			}else{
				var orign = $this.attr('data-rank');
				$this.val(orign);
				return;
			}
		}else if(allType == 'bidSet' || allType == 'bidCpa' || allType == 'bidOpp') {
			var comment = (allType == 'bidSet') ? '목표순위, 최대 입찰가를 일괄설정 하시겠습니까?':(allType == 'bidCpa') ? '목표CPA, 최대 입찰가를 일괄설정 하시겠습니까?':'타겟 목표순위, 최대 입찰가를 일괄설정 하시겠습니까?';
			var success = false;
			var setMax = Number($('#max-bid-input').val());
			var setMin = Number($('#min-bid-input').val());

			//최대,최소입찰가 필터
			if('' === setMax || '' === setMin) {
				alert('최대입찰가,최소입찰가를 입력해 주세요.');
				success = false;
				return;
			}else if(0 < setMax && 0 < setMin) {
				if(setMin < setMax) {
					if((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
						success = true;
					}else{
						alert('최소입찰가,최대입찰가는 70원 미만으로 설정할 수 없습니다.');
						success = false;
						return;
					}
				}else{
					alert('최대입찰가는 최소입찰가보다 작거나 동일하게 설정할 수 없습니다.');
					success = false;
					return;
				}
			}else{
				if((0 == setMax || 70 <= setMax) && (0 == setMin || 70 <= setMin)) {
					success = true;
				}else{
					alert('최대입찰가,최소입찰가는 70원 미만으로 설정할 수 없습니다.');
					success = false;
					return;
				}
			}

			if(success == true) {
				if(confirm(comment) == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					var setKey = '';
					var eRemoveEl = '';
					var messageCount = 0;

					if(allType == 'bidSet') {
						var afterKeys = ['goal_rank','max_bid_amt','min_bid_amt','bid_status'];
						var beforeKeys = ['before_goal_rank','before_max_bid_amt','before_min_bid_amt','before_bid_status'];
						var eAddEl = ['.bid-rank-option option','.max_bid_price','.min_bid_price'];
						eRemoveEl = '.bid-rank-option option, .max_bid_price, .min_bid_price';
					}else if(allType == 'bidCpa') {
						var afterKeys = ['goal_cpa_amt','max_bid_amt','min_bid_amt','bid_status'];
						var beforeKeys = ['before_goal_cpa_amt','before_max_bid_amt','before_min_bid_amt','before_bid_status'];
						var eAddEl = ['.goal_cpa_price','.max_bid_price','.min_bid_price'];
						eRemoveEl = '.goal_cpa_price, .max_bid_price, .min_bid_price';
					}else if(allType == 'bidOpp') {
						var afterKeys = ['opp_gap','opp_goal_rank','max_bid_amt','min_bid_amt','opp_site','bid_status'];
						var beforeKeys = ['before_opp_gap','before_opp_goal_rank','before_max_bid_amt','before_min_bid_amt','before_opp_site','before_bid_status'];
						var eAddEl = ['.opp-gap','.opp_goal_rank','.max_bid_price','.min_bid_price'];
						eRemoveEl = '.opp-gap, .opp_goal_rank, .max_bid_price, .min_bid_price';
					}
					setKey = afterKeys;


					if(0 < setKey.length) {
						for(var i = 0; i < setKey.length; i++) {
							changeKey.push(setKey[i]);
						}
					}
					$this.find('tr').each(function() {
						var $this = $(this);
						var key = $this.attr('data-id');
						var $this2 = $('#bid-list-body-2').find('.' + key);
						var bidStatusCheck = $this2.find('.bidStatus-td > p').attr('data-status');
						var check = $this.find("input[type='checkbox']").prop('checked');
						//&& bidStatusCheck != 'Inactive'
						if(check == true) {
							keywords = faListData[key];
							//목표순위, 최대 입찰가 일괄설정
							if(allType == 'bidSet') {
								var targetCheck = keywords.target;

								for(var i = 0; i < afterKeys.length; i++ ) {
									if(i <= 2) {
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										if(targetCheck == 'mobile' && Number(bidSetSaveKeywordData[key]['goal_rank']) > 15 && messageCount === 0) {
											messageCount++;
											alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
											keywords[afterKeys[i]] = keywords[afterKeys[i]];
										}else{
											keywords[afterKeys[i]] = Number(bidSetSaveKeywordData[key][afterKeys[i]]);
										}
										$this2.find(eAddEl[i]).addClass('effect');
										if(i == 0) {
											$this2.find(eAddEl[i]).eq(Number(bidSetSaveKeywordData[key][afterKeys[i]] - 1)).prop('selected', true);
										}else{
											$this2.find(eAddEl[i]).text(bidSetSaveKeywordData[key][afterKeys[i]]);
										}
									}else{
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										if(targetCheck == 'mobile' && Number(bidSetSaveKeywordData[key]['goal_rank']) > 15 && messageCount === 0) {
											messageCount++;
											alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
											keywords[afterKeys[i]] = keywords[afterKeys[i]];
										}else{
											keywords[afterKeys[i]] = 'Active';
										}
									}
								}
							//목표CPA 일괄설정
							}else if(allType == 'bidCpa') {

								for(var i = 0; i < afterKeys.length; i++ ) {
									if(i <= 2) {
										if(i == 0) {
											keywords[afterKeys[i]] = (keywords[afterKeys[i]] == null) ? 0:keywords[afterKeys[i]];
										}
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										keywords[afterKeys[i]] = bidCpaSaveKeywordData[key][afterKeys[i]];
										$this2.find(eAddEl[i]).addClass('effect');
										$this2.find(eAddEl[i]).text(bidCpaSaveKeywordData[key][afterKeys[i]]);
									}else{
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										keywords[afterKeys[i]] = 'CpaActive';
									}
								}

							//경쟁사 일괄설정
							}else if(allType == 'bidOpp'){

								for(var i = 0; i < afterKeys.length; i++ ) {
									if(i <= 1) {
										//경쟁사 현재순위
										keywords[beforeKeys[i]] = (keywords[afterKeys[i]] == null) ? 0:keywords[afterKeys[i]];
										keywords[afterKeys[i]] = Number(bidOppSaveKeywordData[key][afterKeys[i]]);
									}else if(i <= 3) {
										//최대입찰가
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										keywords[afterKeys[i]] = bidOppSaveKeywordData[key][afterKeys[i]];
										$this2.find(eAddEl[i]).addClass('effect');
										$this2.find(eAddEl[i]).text(bidOppSaveKeywordData[key][afterKeys[i]]);
									}else if(i == 4){
										//경쟁사 사이트
										keywords[beforeKeys[i]] = (keywords.opp_site == null) ? '':keywords[afterKeys[i]];
										keywords[afterKeys[i]] = bidOppSaveKeywordData[key][afterKeys[i]];
									}else{
										//입찰상태
										keywords[beforeKeys[i]] = keywords[afterKeys[i]];
										keywords[afterKeys[i]] = 'OppActive';
									}
								}

							}
							listArray.push(keywords);
						}
					});

					AjaxLoading.pageLoading('time');
					setTimeout(function() {
						favoriteFunc.favoriteSubListData(advSubId, 'sync');
					}, 1000);
					setTimeout(function() {
						$this.find('tr').find(eRemoveEl).removeClass('effect');
					}, 1500);
				}else{
					return;
				}
			}

		}else if(allType == 'mutiCurBid') {
			//다중  입찰가 일괄설정
			if(confirm('선택한 키워드의 입찰가를 변경하시겠습니까?') == true) {
				ajaxType = 'POST';
				updateType = 'type1';
				var $radio = $('.amt-choices:checked');
				var $parentLi = $radio.closest('li');
				var checkVal = Number($parentLi.find('.change-value').val());
				var changeValueType = $parentLi.find('.change-value-type').val();
				var selectVal = $radio.closest('li').find('.select-value').val();
				var $table = $('#bid_amt_preview_table');
				var optionCheck = $('#option').prop('checked');
				var key = ['cur_bid_amt','bid_status'];
				for(var i = 0; i < key.length; i++) {
					changeKey.push(key[i]);
				}


				var setFunctions = function(check) {
					$table.find('tbody tr').each(function() {
						var dataKey = $(this).attr('data-key');
						var values = checkVal;

						if(check == 'perI' || check == 'perD') {
							if(changeValueType == '원') {
								if(check == 'perI') {
									var values = bidChangeList[dataKey].cur_bid_amt + checkVal;
								}else{
									var values = bidChangeList[dataKey].cur_bid_amt - checkVal;
								}
							}else{
								var values = bidChangeList[dataKey].cur_bid_amt * (1+checkVal/100);
							}
						}

						if(optionCheck == true) {
							maxAmt = $('#option-max-bid-amt').val();
							if(maxAmt < values) {
								values = maxAmt;
							}
						}


						var price = favoriteFunc.bidAmtRound(Number(values));
						bidChangeList[dataKey]['before_bid_status'] = bidChangeList[dataKey].bid_status;
						bidChangeList[dataKey]['before_bid_amt'] = bidChangeList[dataKey].cur_bid_amt;
						bidChangeList[dataKey]['bid_status'] = 'Inactive';
						bidChangeList[dataKey]['cur_bid_amt'] = price;


						$(this).find('.bid_price').text(numberWithCommas(price));
						actions(dataKey, price);
						listArray.push(bidChangeList[dataKey]);
					});
				};

				var actions = function(key,price) {
					var $list = $('#bid-list-body-2 .' + key);
					$list.find('.cur_bid_price').text(numberWithCommas(price));
					$list.find('.bid-status-btn').removeClass('on');
					$list.find('.bid-status-Inactive').addClass('on');
					$list.find('.bid-cur-option').prop('disabled', false);
					$list.find('.bid-rank-option, .bid-max-option, .bid-min-option').prop('disabled', true);
				}

				switch($radio.val()){
					case 'SAME' :
						setFunctions();
						break;
					case 'INCREASE' :
						setFunctions('perI');
						break;
					case 'DECREASE' :
						setFunctions('perD');
						break;
					case 'MID_AMT' :
					case 'AVG_AMT' :
						var params = '?na_customer=' + advKey;
								params +='&view_bid_type=' + selectVal;
								params +='&na_kwd_sers=' + favoriteFunc.makeCheckedBiddingListKeywordKeyCommaStr(bidChangeList);
						var dataApi = dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
						AjaxLoading.pageLoading();
						ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, favoriteFunc.setCurBidAmtByNaverSaveAPI);
						$table.find('tbody tr').each(function() {
							var dataKey = $(this).attr('data-key');
							var values = naverSaveAPIData[dataKey].bid;

							if(optionCheck == true) {
								var maxAmt = $('#option-max-bid-amt').val();
								if(maxAmt < values) {
									values = maxAmt;
								}
							}
							var price = favoriteFunc.bidAmtRound(Number(values));

							bidChangeList[dataKey]['before_bid_amt'] = bidChangeList[dataKey].cur_bid_amt;
							bidChangeList[dataKey]['cur_bid_amt'] = price;

							$(this).find('.bid_price').text(numberWithCommas(price));
							$('#bid-list-body-2 .' + dataKey).find('.cur_bid_price').text(numberWithCommas(price));
							listArray.push(bidChangeList[dataKey]);
						});
						break;
				}
				AjaxLoading.pageLoading('time');
				setTimeout(function() {
					favoriteFunc.favoriteSubListData(advSubId, 'sync');
					$bidListTr.find('.cur_bid_price').addClass('effect');
					setTimeout(function() {
						$bidListTr.find('.cur_bid_price').removeClass('effect');
					}, 500);
				}, 1000);
			}else{
				return;
			}
		}else if(type == 'resvStatus') {
			var bidOnCheck = $this.parents('tr').find('.bid-status-active').hasClass('on');
			var cpaOnCheck = $this.parents('tr').find('.cpa-status-active').hasClass('on');
			var oppOnCheck = $this.parents('tr').find('.opp-status-active').hasClass('on');
			var value = $this.attr('data-status');
			if(bidOnCheck == true || cpaOnCheck == true || oppOnCheck == true || value == 'Inactive') {
				//예약 변경 : on/off
				if($this.hasClass('on') !== true) {
					if(confirm("변경 하시겠습니까?") == true) {
						ajaxType = 'PUT';
						updateType = 'type3';
						var key = $this.attr('data-name');
						changeKey.push(key);
						keywords['before_revs_status'] = keywords[key];
						keywords[key] = value;

						listArray.push(keywords);
						//버튼 이벤트
						$('.' + keyId).find('.resv-status-btn').removeClass('on');
						$this.addClass('on');
					}else{
						return;
					}
				}else{
					return;
				}
			}else{
				alert('먼저 자동입찰을 선택해주세요.');
				return;
			}
		}else if(type == 'bidStatus') {
			//입찰유형 변경 : 자동 /수동
			if($this.hasClass('on') !== true) {
				var $keyEl = $('.' + keyId);
				var value = $this.attr('data-status');
				var comment = (value == 'Inactive') ? '입찰상태를 OFF로 변경하시면 예약 상태도 OFF로 변경됩니다. 변경하시겠습니까?':"변경 하시겠습니까?";
				if(confirm(comment) == true) {
					ajaxType = 'PUT';
					updateType = 'type3';
					var key = $this.attr('data-name');
					changeKey.push(key);
					keywords['before_bid_status'] = keywords[key];
					keywords[key] = value;

					listArray.push(keywords);
					var statusText = (value == 'Inactive') ? '수동':(value == 'Active') ? '목표순위':(value == 'CpaActive') ? '목표CPA':'경쟁사 타겟';

					if(value == 'Inactive') {
						keywords['before_resv_status'] = keywords['resv_status'];
						keywords['resv_status'] = 'Inactive';
						changeKey.push('resv_status');
						$('.' + keyId).find('.resv-status-active').removeClass('on');
					}


					//버튼 이벤트
					$this.parents('tr').find('.bidStatus-td > p').attr('data-status', value).text(statusText);
					$keyEl.find('.bid-status-btns').removeClass('on');
					$keyEl.find('.bid-status-Inactives').addClass('on');
					if(value != 'Inactive') {
						$this.addClass('on');
						$this.next().removeClass('on');
					}
					if(value == 'Inactive') {
						$keyEl.find('.bid-cur-option').prop('disabled', false);
						$keyEl.find('.bid-rank-option, .bid-max-option, .bid-min-option, .bid-cpa-option, .target_btn').prop('disabled', true);
					}else if(value == 'Active') {
						$keyEl.find('.bid-cur-option, .bid-cpa-option, .target_btn').prop('disabled', true);
						$keyEl.find('.bid-rank-option, .bid-max-option, .bid-min-option').prop('disabled', false);
					}else if(value == 'CpaActive') {
						$keyEl.find('.bid-cur-option, .bid-rank-option, .target_btn').prop('disabled', true);
						$keyEl.find('.bid-cpa-option, .bid-max-option, .bid-min-option').prop('disabled', false);
					}else if(value == 'OppActive') {
						$keyEl.find('.bid-cur-option, .bid-rank-option, .bid-cpa-option').prop('disabled', true);
						$keyEl.find('.target_btn, .bid-max-option, .bid-min-option').prop('disabled', false);
					}
				}else{
					return;
				}
			}else{
				return;
			}
		}else if(allType == 'AllBidStatus') {
			//전체 상태 값 변경
			if(confirm("변경 하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type3';
				$this.find('tr').each(function(i) {
					var $this = $(this);
					var check = $this.find("input[type='checkbox']").prop('checked');
					if(check == true) {
						var onCheck = $(this).find('.bidStatus-btn-area .bid-status-' + condition).hasClass('on');
						if(onCheck != true) {
							var value = $(this).find('.bidStatus-td > p').attr('data-status');
							var key = $this.attr('data-id');
							var name = $this.attr('data-name');
							multi = true;

							keywords = faListData[key];
							$this.find('.bidStatus-btn-area button').removeClass('on');
							if(condition == 'Active') {
								$this.find('.bid-status-Active').addClass('on');
								keywords['bid_status'] = 'Active';
							}else{
								$this.find('.bid-status-Inactive').addClass('on');
								keywords['bid_status'] = 'Inactive';
							}
							keywords['before_bid_status'] = value;

							listArray.push(keywords);
						}
					}
				});
				changeKey.push('bid_status');
			}else{
				return;
			}
			if(multi == false) {
				alert('변경 할 수 있는 키워드가 없습니다.');
			}
		}else if(type == 'curBid') {
			//입찰가를 변경
			if(confirm('입찰가를 반영하시겠습니까?') == true) {
				ajaxType = 'POST';
				updateType = 'type1';
				var key = $this.parent().find('input').attr('name');
				var value = favoriteFunc.bidAmtRound($this.parent().find('input').val());
				if(70 <= value) {
					changeKey.push(key);
					keywords['before_bid_amt'] = keywords[key];
					keywords[key] = value;
					if(bidChangeList[keyId] != undefined) {
						bidChangeList[keyId]['cur_bid_amt'] = value;
					}

					listArray.push(keywords);

					$(subEl).find('.bid_icon').show();
					$(subEl).find('.bid_price').show();
					$(subEl).find('.active-btn-area').hide();
					//입찰가 변경 저장
					$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
					$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
					setTimeout(function() {
						$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
					}, 500);
				}else{
					alert('입찰가는 70원 미만으로 설정할 수 없습니다.');
					return;
				}
			}else{
				return;
			}
		}else if(type == 'bidMax') {
			//최대 입찰가 설정
			if(confirm("변경 하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type3';
				var key = $this.parent().find('input').attr('name');
				var value = Number($this.parent().find('input').val());
				var bidMin = keywords['min_bid_amt'];

				var bidMaxFunc = function(amt) {

					changeKey.push(key);
					keywords['before_max_bid_amt'] = keywords[key];
					keywords[key] = value;

					listArray.push(keywords);

					$(subEl).find('.bid_icon').show();
					$(subEl).find('.bid_price').show();
					$(subEl).find('.active-btn-area').hide();
					$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
					$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
					setTimeout(function() {
						$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
					}, 500);

				}

				if(0 < bidMin) {
					if(value > bidMin) {
						if(0 == value || 70 <= value) {
							bidMaxFunc();
						}else{
							alert('최대입찰가는 70원 미만으로 설정할 수 없습니다.');
							return;
						}
					}else{
						alert('최대입찰가는 최소입찰가보다 작거나 동일하게 설정할 수 없습니다.');
						return;
					}
				}else{
					if(0 == value || 70 <= value) {
						bidMaxFunc();
					}else{
						alert('최대입찰가는 70원 미만으로 설정할 수 없습니다.');
						return;
					}
				}
			}else{
				return;
			}
		}else if(type == 'bidMin') {
			//최소 입찰가 설정
			if(confirm("변경 하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type3';
				var key = $this.parent().find('input').attr('name');
				var value = $this.parent().find('input').val();
				var bidMax = keywords['max_bid_amt'];

				var bidMinFunc = function(amt) {

					changeKey.push(key);
					keywords['before_min_bid_amt'] = keywords[key];
					keywords[key] = value;

					listArray.push(keywords);

					$(subEl).find('.bid_icon').show();
					$(subEl).find('.bid_price').show();
					$(subEl).find('.active-btn-area').hide();
					$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
					$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
					setTimeout(function() {
						$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
					}, 500);

				}

				if(0 < bidMax) {
					if(value < bidMax) {
						if(0 == value || 70 <= value) {
							bidMinFunc();
						}else{
							alert('최소입찰가는 70원 미만으로 설정할 수 없습니다.');
							return;
						}
					}else{
						alert('최소입찰가는 최대입찰가를 초과하거나 동일하게 설정할 수 없습니다.');
						return;
					}
				}else{
					if(0 == value || 70 <= value) {
						bidMinFunc();
					}else{
						alert('최소입찰가는 70원 미만으로 설정할 수 없습니다.');
						return;
					}
				}
			}else{
				return;
			}
		}else if(type == 'goalCpa') {
			//최소 입찰가 설정
			if(confirm("변경 하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type3';
				var key = $this.parent().find('input').attr('name');
				var value = favoriteFunc.bidAmtRound($this.parent().find('input').val());

				changeKey.push(key);
				keywords['before_goal_cpa_amt'] = keywords[key];
				keywords[key] = value;

				listArray.push(keywords);

				$(subEl).find('.bid_icon').show();
				$(subEl).find('.bid_price').show();
				$(subEl).find('.active-btn-area').hide();
				$this.parents('.bid_wrap').find('.bid_price').text(numberWithCommas(value));
				$this.parents('.bid_wrap').find('.bid_price').addClass('effect');
				setTimeout(function() {
					$this.parents('.bid_wrap').find('.bid_price').removeClass('effect');
				}, 500);
			}else{
				return;
			}
		}else if(allType == 'bidDelete') {
			//즐겨찾기 삭제
			if(confirm('선택된 키워드를 삭제하시겠습니까?') == true) {
				ajaxType = 'DELETE';
				updateType = 'type3';
				$this.find('tr').each(function() {
					var $this = $(this);
					var key = $this.attr('data-id');
					var $this2 = $('#bid-list-body-2').find('.' + key);
					var check = $this.find("input[type='checkbox']").prop('checked');
					if(check == true) {
						keywords = faListData[key];
						$(this).remove();
						$this2.remove();

						listArray.push(keywords);
					}
				});
			}else{
				return;
			}
		}else if(type == 'status'){
			//ON/OFF 상태값변경
			ajaxType = 'POST';
			updateType = 'type2';
			var check = $this.hasClass('on');
			if(check != true) {
				if(confirm("변경 하시겠습니까?") == true) {
					var thisId = $this.attr('data-status');
					var key = $this.attr('data-name');
					var value;
					multi = true;
					$this.parent('.status-btn-area').find('button').each(function() {
						var check = $(this).hasClass('on');
						if(check == true) {
							value = $(this).attr('data-status');
						}
					});
					$this.parent('.status-btn-area').find('button').removeClass('on');
					$this.addClass('on');
					keywords['before_status'] = value;
					keywords[key] = thisId;
					listArray.push(keywords);
				}else{
					return;
				}
			}else{
				return;
			}
		}else if(allType == 'status'){
			//전체 상태 값 변경
			if(confirm("변경 하시겠습니까?") == true) {
				ajaxType = 'POST';
				updateType = 'type2';
				$this.find('tr').each(function(i) {
					var $this = $(this);
					var check = $this.find("input[type='checkbox']").prop('checked');
					if(check == true) {
						var onCheck = $(this).find('.status-btn-area .status-' + condition).hasClass('on');
						if(onCheck != true) {
							var value = $(this).find('.status-btn-area .on').attr('data-status');
							var key = $this.attr('data-id');
							var name = $this.attr('data-name');
							multi = true;

							keywords = faListData[key];
							$this.find('.status-btn-area button').removeClass('on');
							if(condition == 'on') {
								$this.find('.status-on').addClass('on');
								keywords['status'] = 'ELIGIBLE';
							}else{
								$this.find('.status-off').addClass('on');
								keywords['status'] = 'PAUSED';
							}
							keywords['before_status'] = value;


							listArray.push(keywords);
						}
					}
				});
			}else{
				return;
			}
			if(multi == false) {
				alert('변경 할 키워드를 선택해주세요.');
			}
		}else if(type == 'opp') {
			if(confirm("저장하시겠습니까?") == true) {
				var keyId = $this.attr('data-id');
				var keywords = faListData[keyId];
				//순위변경
				ajaxType = 'PUT';
				updateType = 'type3';
				var $urlEl = $('#target-url');
				var $gapEl = $('#target-gap');
				var $rankEl = $('#target-rank');
				var urlKey = $urlEl.attr('name');
				var gapKey = $gapEl.attr('name');
				var rankKey = $rankEl.attr('name');
				var setKey = [urlKey,gapKey,rankKey];
				var urlVal = $urlEl.val();
				var gapVal = $gapEl.val();
				var rankVal = $rankEl.val();
				if(urlVal == '' || rankVal == '') {
					alert('경쟁사 표시 URL을 입력하세요.');
					$urlEl.focus();
					return;
				}else{
					if(0 < setKey.length) {
						for(var i = 0; i < setKey.length; i++) {
							changeKey.push(setKey[i]);
						}
					}
					keywords['before_opp_site'] = (keywords[urlKey] == null) ? '':keywords[urlKey];
					keywords[urlKey] = urlVal;
					keywords['before_opp_gap'] = (keywords[gapKey] == null) ? 0:keywords[gapKey];
					keywords[gapKey] = Number(gapVal);
					keywords['before_opp_goal_rank'] = (keywords[rankKey] == null) ? 0:keywords[rankKey];
					keywords[rankKey] = Number(rankVal);
					listArray.push(keywords);
				}
			}else{
				return;
			}
		}else if(type == 'schedule' || type == 'scheduleAll') {
			if(confirm("저장하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type4';
				var $addList = $('#add-key-list');
				var ajaxGate = true;
				var kwdKeys = [];
				if(type == 'schedule') {
					var kwdKey = $this.attr('data-key');
					var kwdObj = {
						"kwd_id":kwdKey
					};
					kwdKeys.push(kwdObj);
				}else{
					var messageCount = 0;
					$addList.find('li').each(function() {
						var $this = $(this);
						var kwdKey = $this.attr('data-kwd');
						var kwdObj = {
							"kwd_id":kwdKey
						};
						//모바일 및 목표순위 체크
						var deviceCheck = faListData[kwdKey].target;
						var clickDataType = bidScheAllData[bidScheAllClickKwd].bid_schedule_types;
						var pushGate = true;
						var clickDataKey = Object.keys(clickDataType);
						for(var i = 0; i < clickDataKey.length; i++) {
							var goalRank = clickDataType[clickDataKey[i]].goal_rank;
							if(deviceCheck == 'mobile' && goalRank > 15) {
								if(messageCount === 0) {
									alert('설정 목표순위가 15이상 입니다. 모바일 키워드는 적용이 제외됩니다.');
								}
								messageCount++;
								pushGate = false;
							}
						}

						if(pushGate == true) {
							kwdKeys.push(kwdObj);
						}
						if(kwdKeys.length == 0) {
							ajaxGate = false;
						}
					});

				}

				if(ajaxGate === false) {
					alert('변경 가능한 키워드가 없습니다.');
					return false;
				}

				var schKwd = kwdKeys;
				var $gridBox = $('.grid-box');
				var $gridCell = $('.box-grid');
				var $schList = $('.add-sch-list');
				var schedulData = '';
				var colorBox = {};

				$gridBox.find('.box-line').each(function() {
					var $this = $(this);
					$this.find('.box-grid').each(function() {
						var $this = $(this);
						var colorData = $this.attr('data-color');
						if(colorData == '' || colorData == null) {
							colorData = 0;
						}
						schedulData += ',' + String(colorData);
					});
				});

				schedulData = schedulData.replace(',','');
				if(type == 'schedule') {
					$schList.find('.add-type-btn').each(function() {
						var $this = $(this);
						var dataNm = $this.attr('data-nm');
						var dataType = $this.attr('data-type');
						var dataRank = Number($this.attr('data-rank'));
						var dataMax = $this.attr('data-max');
						var dataMin = $this.attr('data-min');
						var dataCpa = $this.attr('data-cpa');
						var dataColor = $this.attr('data-color');
						if(dataType == 'Active') {
							colorBox[dataColor] = {
								"nm": dataNm,
				                "bid_status": dataType,
				                "goal_rank": dataRank,
				                "max_bid_amt": dataMax,
				                "min_bid_amt":dataMin,
				                "goal_cpa": 0
							}
						}else{
							colorBox[dataColor] = {
								"nm": dataNm,
				                "bid_status": dataType,
				                "goal_rank": 0,
				                "max_bid_amt": dataMax,
				                "min_bid_amt":dataMin,
				                "goal_cpa": dataCpa
							}
						}
					});
				}else{
					colorBox = bidScheAllData[bidScheAllClickKwd].bid_schedule_types;
				}
				AjaxLoading.pageLoading('time');
				setTimeout(function() {
					favoriteFunc.favoriteSubListData(advSubId, 'sync');
				}, 1000);
			}else{
				return;
			}

		} else if(type == 'rate' || type == 'rateCpa' || type == 'rateAll') {
			if(confirm("저장하시겠습니까?") == true) {
				ajaxType = 'PUT';
				updateType = 'type5';
				var $addList = $('#add-key-list');
				var kwdKeys = [];
				if(type.indexOf('All') === -1) {
					var kwdKey = $this.attr('data-key');
					var target = faListData[kwdKey].target;
					var kwdObj = {
						"kwd_id":kwdKey,
						"target":target
					};
					kwdKeys.push(kwdObj);
					var bidType = (type.indexOf('Cpa') === -1) ? 'rank':'cpa';
				}else{
					$addList.find('li').each(function() {
						var $this = $(this);
						var kwdKey = $this.attr('data-kwd');
						var target = faListData[kwdKey].target;
						var kwdObj = {
							"kwd_id":kwdKey,
							"target":target
						};
						kwdKeys.push(kwdObj);
					});

					var bidType = $('.rate-tab-box').find('.active').attr('data-name');
				}

				var rateKwd = kwdKeys;
				var rateType = $('#rate-type select').val();
				var tables = (bidType === 'rank') ? '#goal-rate':'#cpa-rate';
				var eachs = function(el) {
					var returnData = {};
					$(el).each(function(i) {
						if(0 < i) {
							var thisVal = Number($(this).find('input').val());
							var value = (thisVal === '') ? 0:thisVal;
							returnData[i] = value;

						}
					});
					return JSON.stringify(returnData);
				}
				//증액
				var incData = eachs(tables + ' tbody .inc td');
				//감액
				var decData = eachs(tables + ' tbody .dec td');

				AjaxLoading.pageLoading('time');
				setTimeout(function() {
					favoriteFunc.favoriteSubListData(advSubId, 'sync');
				}, 1000);
			}else{
				return;
			}
		}


		if(updateType == 'type1') {
			var request = {
				"adv_id":Number(advId),
				"update_fields" :changeKey,
				"keywords" :listArray
			};
			var dataApi = dataUrl.favoriteAPI(ajaxType,'update_bid');
			ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
		}else if(updateType == 'type2') {
			if(multi == true) {
				var request = {
					"adv_id":Number(advId),
					"update_fields" :changeKey,
					"keywords" :listArray
				};
				var dataApi = dataUrl.favoriteAPI(ajaxType,'updateStatus');
				ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
				multi = false;
			}else{
				var request = {
					"adv_id":Number(advId),
					"update_fields" :changeKey,
					"keywords" :listArray
				};
			}
		}else if(updateType == 'type3'){
			var request = {
				"adv_id":Number(advId),
				"update_fields" :changeKey,
				"keywords" :listArray
			};
		}else if(updateType == 'type4') {
			var request = {
			    "update_schedule": {
			        "bid_schedule_types": colorBox,
			        "bid_schedule": schedulData
			    },
			    "bid_schedules": schKwd
			};
			var dataApi = dataUrl.favoriteAPI(ajaxType,'schedule');
			ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
		}else if(updateType == 'type5') {
			var request = {
				"update_bid_variation" : {
					"increse_json" :incData,
					"decrese_json" :decData,
					"type" : rateType,
					"bid_type" : bidType
				},
				"bid_variations" : rateKwd
			}

			var dataApi = dataUrl.favoriteAPI(ajaxType,'rate');
			ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
		}
		if(updateType == 'type3') {
			var dataApi = dataUrl.favoriteAPI(ajaxType,'update');
			ajaxFrame.ajaxDataCall(ajaxType, dataApi, 'json', true, favoriteFunc.favoriteChangeCallBack, request);
		}
	},


	//리스트 상태 키워드 값 데이터
	favoriteListStatusData:function(data) {
		var statusKey = Object.keys(statusKwd);
		var statusValue = statusKey.map(function(key) {
			return statusKwd[key];
		});
		var param = "?na_customer=" + advKey + "&na_kwd_sers=";
		if(0 < statusKey.length) {
			for(var i = 0; i < statusKey.length; i++) {
				if(1 > i) {
					param += statusValue[i];
				}else{
					param += ',' +statusValue[i];
				}
			}
			var dataApi = dataUrl.favoriteAPI('GET','keyStatus', param);
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', false, favoriteFunc.favoriteStatusCallBack);
		}
	},


	//전체 리스트 상태 데이터
	favoriteStatusChangeData:function(thisEl) {
		var $this = $(thisEl);
		var thisId = $this.attr('data-id');
		$this.parent('.on_off_btn').find('button').removeClass('on');
		$this.addClass('on');
	},


	//키워드 이동 팝업
	favoriteKeywordMovePop:function() {
		var $this = $('#bid-list-body-1');
		var keywordList = [];
		moveKeywordData = {};
		$this.find('tr').each(function() {
			var $this = $(this);
			var check = $this.find("input[type='checkbox']").prop('checked');
			if(check == true) {
				var key = $this.attr('data-id');
				var checklist = faListData[key];
				keywordList.push(checklist);
			}
		});
		if(0 < keywordList.length) {
			var subListData = alwaysFunc.favoriteSubListSave();
			favoriteFunc.favoriteKeywordMoveGroupCallBack(subListData, keywordList);
		}else{
			alert('키워드를 선택해 주세요.');
			return false;
		}
	},


	//즐겨찾기 테이블 제어 필터
	favoriteFilterData:function(key) {
		var listKey = [];
		$('#bid-list-body-1').find('tr').each(function() {
			if($(this).hasClass('hide') != true) {
				listKey.push($(this).attr('data-id'));
			}
		});
		var data = {};
		var forKey = ['status','target','campaign_nm','adgroup_nm','bid_status','bid_status','bid_status','bid_status','resv_status'];
		var keyArray = ['status','target','campaign_nm','adgroup_nm','bid_status','bid_status_a','bid_status_b','bid_status_c','resv_status'];
		var dataPushs = function(keyI) {
			for(var i2 = 0; i2 < listKey.length; i2++) {
				if (keyFilter != faListData[listKey[i2]][forKey[keyI]]) {
					data[faListData[listKey[i2]][forKey[keyI]]] = [];
				}
				keyFilter = faListData[listKey[i2]][forKey[keyI]];
			}
			for(var i3 = 0; i3 < listKey.length; i3++) {
				data[faListData[listKey[i3]][forKey[keyI]]].push(listKey[i3]);
			}
		}
		for(var i = 0; i < keyArray.length; i++) {
			var keyFilter = null;
			if(key == 'status') {
				var dataCheck = Object.keys(statusData);
				if(0 < dataCheck.length) {
					dataPushs(i);
				}
			}else if(key == keyArray[i]) {
				dataPushs(i);
			}
		}
		var dataKeyChange = function(deleteKey, activeKey) {
			for(var i = 0; i < deleteKey.length; i++) {
				if(data[deleteKey[i]] != undefined) {
					for(var idx = 0; idx < data[deleteKey[i]].length; idx++) {
						if(data[activeKey] == undefined) {
							data[activeKey] = new Array();
						}
						data[activeKey].push(data[deleteKey[i]][idx]);
					}
					delete data[deleteKey[i]];
				}
			}
		};

		var customKeys = ['bid_status','bid_status_a','bid_status_b','bid_status_c'];
		for(var str = 0; str < customKeys.length; str++) {
			var deleteKey = (str <= 1) ? ['CpaActive','OppActive']:(str == 2) ? ['Active','OppActive']:['Active','CpaActive'];
			var activeKey = (str == 0) ? 'Active':'Inactive';
			if(key == customKeys[str]) {
				dataKeyChange(deleteKey, activeKey);
			}
		}

		tableFilterData['data'] = data;
		tableFilterData['key'] = key;
		favoriteFunc.favoriteFilterCallBack(data, key);
	},

	//즐겨찾기 리스트 새로고침
	favoriteListReData:function() {
		var searchKey = '';
		if(advSubId != null) {
			searchKey = 'bid_favorite_id=' + advSubId;
			// if(searchData != null) {
			// 	searchKey += '&' + searchData;
			// }
		}else{
			searchKey = 'adv_id=' + advId;
		}
		var param = '?' + searchKey;
		AjaxLoading.pageLoading();
		var dataApi = dataUrl.favoriteAPI('GET','sort', param);
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteListCallBack);
	},

	//즐겨찾기 입찰가 변경 팝업
	favoriteBidAllChangePopUp:function() {
		bidChangeList = {};
		var keywordList = [];
		if(historyKey != null) {
			var keywords = faListData[historyKey];
			keywordList.push(keywords);
			var subListData = alwaysFunc.favoriteSubListSave();
			favoriteFunc.favoriteBidAllChangePopUpCallBack(subListData, keywordList);
			historyKey = null;
		}else{
			var $this = $('#bid-list-body-1');
			var $list2 = $('#bid-list-body-2');
			$this.find('tr').each(function() {
				var $this = $(this);
				var key = $this.attr('data-id');
				var $this2 = $list2.find('.' + key);
				var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
				var check = $this.find("input[type='checkbox']").prop('checked');
				//&& bidStatusCheck == 'Inactive'
				if(check == true) {
					var checklist = faListData[key];
					keywordList.push(checklist);
				}
			});
			var subListData = alwaysFunc.favoriteSubListSave();
			favoriteFunc.favoriteBidAllChangePopUpCallBack(subListData, keywordList);
		}
	},

	//즐겨찾기 입찰가 변경
	favoriteBidUpdateData:function() {
		if( confirm('선택한 키워드의 입찰가를 변경하시겠습니까?') == false ){
			return;
		}
		var request = {
			adv_id : advId,
			keywords : new Array()
		}
		var dataApi = dataUrl.favoriteAPI('POST','update_bid');
		ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, biddingFunc.afterSaveCurrentAmt, sendData);
	},

	//즐겨찾기 동기화
	favoriteNaSyncData:function() {
		if(advSubId != null) {
			if(confirm('작업시간이 다소 소요됩니다. 동기화 하시겠습니까?') == true) {
				var param = '?adv_id=' + advId + '&favorite_id=' + advSubId;
				var dataApi = dataUrl.favoriteAPI('POST','naSync', param);
				AjaxLoading.pageLoading('time');
				ajaxFrame.ajaxDataCall('POST', dataApi, 'json', true, favoriteFunc.favoriteNaSyncCallBack);
			}else{
				return;
			}
		}
	},


	//즐겨찾기 일괄 설정 데이터
	favoriteBidSetData:function(type, setType) {
		var keywordList = [];
		var subListData = alwaysFunc.favoriteSubListSave();
		var $this = $('#bid-list-body-1');
		var $list2 = $('#bid-list-body-2');
		var reviewOnEl = '#max-bid-input, #goal-cpa, #target-rank, #target-url';
		var comment = (setType == 'bidSet') ? '설정 할 목표순위,최대입찰가를 입력해주세요.':(setType == 'bidCpa') ? '설정 할 목표CPA,최대입찰가를 입력해주세요.':'설정 할 경쟁사URL,경쟁사대비목표순위,최대입찰가를 입력해주세요.';
		if(setType == 'bidSet') {
			//값
			var goalVal = $('#goal-rank-sel').val();
			var maxAmt = $('#max-bid-input').val();
			var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
			var keyData = [goalVal, maxAmt, minAmt];
		}else if(setType == 'bidCpa') {
			//값
			var goalCpa = favoriteFunc.bidAmtRound($('#goal-cpa').val());
			var maxAmt = $('#max-bid-input').val();
			var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
			var keyData = [goalCpa,maxAmt,minAmt];
		}else{
			//값
			var targetUrl = $('#target-url').val();
			var targetGap = Number($('#target-gap').val());
			var targetRank = Number($('#target-rank').val());
			var maxAmt = $('#max-bid-input').val();
			var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
			var minAmt = favoriteFunc.bidAmtRound($('#min-bid-input').val());
			var keyData = [targetGap,maxAmt,minAmt,targetUrl,targetRank];
		}

		if(keyData[0] != '' || keyData[1] != '') {
			if(historyKey != null) {
				var keywords = faListData[historyKey];
				keywordList.push(keywords);
				if(type == 'view') {
					favoriteFunc.favoriteBidSetViewCallBack(subListData, keywordList, keyData, setType);
				}else{
					favoriteFunc.favoriteBidSetSaveCallBack(subListData, keywordList, keyData, setType);
				}
				historyKey = null;
			}else{
				$this.find('tr').each(function() {
					var $this = $(this);
					var key = $this.attr('data-id');
					var $this2 = $list2.find('.' + key);
					var bidStatusCheck = $this2.find('.bidStatus-td > p').attr('data-status');
					var check = $this.find("input[type='checkbox']").prop('checked');
					//&& bidStatusCheck != 'Inactive'
					if(check == true) {
						var checklist = faListData[key];
						keywordList.push(checklist);
					}
				});
				if(type == 'view') {
					favoriteFunc.favoriteBidSetViewCallBack(subListData, keywordList, keyData, setType);
				}else{
					favoriteFunc.favoriteBidSetSaveCallBack(subListData, keywordList, keyData, setType);
				}
				$(reviewOnEl).change(function() {
					var thisVal = $(this).val();
					if(thisVal != '') {
						$('.preview_btn button').prop('disabled',false);
					}else{
						$('.preview_btn button').prop('disabled',true);
					}
				});
			}
		}else{
			alert(comment);
		}
	},

	//즐겨찾기 이력 팝업
	favoriteHistoryPop:function(thisKey) {
		historyKey = thisKey;
		var param = '?na_account_ser=' + advKey + '&kwd_id=' + thisKey;
		var dataApi = dataUrl.favoriteAPI('GET','history', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteHistoryPopCallBack);
		setTimeout(function() {
			$("#fa-date-picker").dateRangeCustomPicker({single: false, autoClose:false});
		}, 500);
	},

	//즐겨찾기 이력 검색
	favoriteHistorySearch:function() {
		var $search = $('#create-date');
		var dateVal = $search.val();
		if(dateVal != '') {
			var dateReplace = dateVal.replace(/-/gi, "");
			var dateSplit = dateReplace.split('~');
			var param = '?na_account_ser=' + advKey + '&kwd_id=' + historyKey;
			if(dateSplit[0] == dateSplit[1]) {
				param += '&to_date=' + dateSplit[0];
			}else{
				param += '&to_date=' + dateSplit[0] + '&from_date=' + dateSplit[1];
			}
			var dataApi = dataUrl.favoriteAPI('GET','history', param);
			AjaxLoading.pageLoading();
			ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteHistoryPopCallBack);
		}
	},
	//즐겨찾기 차트 데이터(검색기능 동일)
	favoriteChartData:function(dataType, thisEl, clickType) {
		if(clickType == 'search') {
			var $this = $(thisEl);
			var $date = $('#create-date');
			var type = $this.attr('data-type');
			var kwdId = $this.attr('data-key');
			var date = $date.val();
			if(date != '') {
				var dateSplit = date.split('~');
				var firstDate = dateSplit[0];
				var endDate = dateSplit[1];
			}
		}else{
			var type = dataType[0];
			var kwdId = dataType[1];
			var d = new Date;
			var yy = d.getFullYear();
			var mm = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
			var dd = (d.getDate() < 10) ? '0' + d.getDate() : d.getDate();
			var firstDate = yy + '-' + mm + '-' + dd;
			var chartTypeActive = function(type) {
	            $('.chart-type-btn button').removeClass('on').attr('data-key', kwdId);
	            $('.chart-type-btn .' + type).addClass('on');
	            $('#create-date').attr('placeholder',firstDate +  '~' + firstDate);
	        };
	        var chartSearchTypes = function() {
	        	var $searchBtn = $('#chart-search-btn, #chart-excel-btn');
	        	$searchBtn.attr('data-type', type).attr('data-key',kwdId);
	        }
	        chartSearchTypes();
	        chartTypeActive(type);
	        setTimeout(function() {
				$("#fa-date-picker.chart-date").dateRangeCustomPicker({single: false, autoClose:false});
			}, 500);
		}

		var dataApiFilter = function(type) {
			var param = type + '/?kwd_id=' + kwdId;
			if(firstDate == endDate || endDate == undefined) {
				param += '&start_date=' + firstDate;
			}else{
				param += '&start_date=' + firstDate + '&end_date=' + endDate;
			}
			var dataApi = dataUrl.favoriteAPI('GET','chart', param);
			return dataApi;
		};
		var charts = (type == 'chart1') ? 'rank':(type == 'chart2') ? 'bid':'cpa';
		$('#chart-excel-btn').attr('data-type', charts);
		var dataApi = dataApiFilter(charts);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteChartCallBack,'', type);
	},
	//차트 엑셀 다운로드
	favoriteChartExcelData:function(thisEl) {
		if(chartDataCheck == true) {
			if(confirm('통계 데이터를 다운로드 하시겠습니까?') == true) {
				var $this = $(thisEl);
				var kwdId = $this.attr('data-key');
				var type = $this.attr('data-type');
				var $date = $('#create-date');
				var date = $date.val();
				var param = '?kwd_id=' + kwdId + '&type=' + type;
				if(date != '') {
					var dateSplit = date.split('~');
					var firstDate = dateSplit[0];
					var endDate = dateSplit[1];
				}else{
					var d = new Date;
					var yy = d.getFullYear();
					var mm = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
					var dd = (d.getDate() < 10) ? '0' + d.getDate() : d.getDate();
					var firstDate = yy + '-' + mm + '-' + dd;
				}
				var dataApiFilter = function() {
					if(firstDate == endDate || endDate == undefined) {
						param += '&start_date=' + firstDate;
					}else{
						param += '&start_date=' + firstDate + '&end_date=' + endDate;
					}
					var dataApi = dataUrl.favoriteAPI('GET','chartExcel', param);
					return dataApi;
				};
				var dataApi = dataApiFilter();
				window.open(dataApi, 'zero_frame');
			}
		}else{
			alert('다운받을 통계데이터가 없습니다.');
		}
	},
	//예약 데이터
	favoriteScheDuleData:function(type) {
		if(type == 'multi') {
			var favoriteId = $(groupSubId).val();
			var param = '?bid_favorites_id=' + favoriteId;
			var callBack = favoriteFunc.favoriteBidSetPopCallBack5;
		}else{
			$('#bid-set-save').attr('data-key',type);
			var kwdArray = [type];
			var param = '?kwd_id=' + type;
			var callBack = favoriteFunc.favoriteBookingCallBack;
		}
		var dataApi = dataUrl.favoriteAPI('GET','schedule', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, callBack, '', kwdArray);
	},

	//증감율 데이터(순위)
	favoriteRateData:function(type) {
		var bidSaveBtn = $('#bid-set-save');
		var rateType = $('#rate-type select').val();
		if(type == 'change') {
			var kwd = bidSaveBtn.attr('data-key');
			var param = '?kwd_id=' + kwd + '&type=' + rateType + '&bid_type=rank';
			if(rateType !== 'pct') {
				$('.default-btn').hide();
			}else{
				$('.default-btn').show();
			}
		}else if(type == 'default') {
			var kwd = bidSaveBtn.attr('data-key');
			var curBidAmt = faListData[kwd].cur_bid_amt;
			var param = '?kwd_id=default&bid_type=rank&type=pct&cur_bid_amt=' + curBidAmt;
		}else{
			var param = '?kwd_id=' + type + '&bid_type=rank';
			$('#rate-type select').attr('data-key',type);
			bidSaveBtn.attr('data-key',type);
		}
		var dataApi = dataUrl.favoriteAPI('GET','rate', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteRateCallBack, '', type);
	},
	//증감율 데이터(CPA)
	favoriteRateCpaData:function(type) {
		var bidSaveBtn = $('#bid-set-save');
		var rateType = $('#rate-type select').val();
		if(type == 'change') {
			var kwd = bidSaveBtn.attr('data-key');
			var param = '?kwd_id=' + kwd + '&type=' + rateType + '&bid_type=cpa';
			if(rateType !== 'pct') {
				$('.default-btn').hide();
			}else{
				$('.default-btn').show();
			}
		}else if(type == 'default') {
			var kwd = bidSaveBtn.attr('data-key');
			var curBidAmt = faListData[kwd].cur_bid_amt;
			var param = '?kwd_id=default&bid_type=cpa&type=pct&cur_bid_amt=' + curBidAmt;
		}else{
			var param = '?kwd_id=' + type + '&bid_type=cpa';
			$('#rate-type select').attr('data-key',type);
			bidSaveBtn.attr('data-key',type);
		}

		var dataApi = dataUrl.favoriteAPI('GET','rate', param);
		AjaxLoading.pageLoading();
		ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.favoriteRateCallBack, '', type);
	},

	//Data or PopUpFunction (End)






















	//CallBack Functions
	favoriteListCallBack:function(data) {
		faListData = data.data;
		var listKeys = Object.keys(faListData);
		var listValues = listKeys.map(function(key) {
			return faListData[key];
		});
		var listHtml1 = '';
		var listHtml2 = '';
		var $count = $('#favorite-area .left_hit .allCount');
		var $list = $('.favorite_table_wrap');
		var $noList = $('.favorite_none_wrap');
		var $search = $('.main_search_wrap');
		var $listBodyPos = $('.position_table tbody');
		var $listBodyFull = $('.favorite_full_table tbody');

		//앞자리 0 추가
		var timeSupport = function(time) {
			var supTime = time;
			var returnTime = (supTime < 10) ? '0' + supTime : supTime;
			return returnTime;
		};

		//타임 계산 로직(연도,월,날짜,시간)
		var times = function(time) {
			var date = new Date(time);
			var yy = date.getFullYear();
			var mm = ((date.getMonth() + 1) < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
			var dd = timeSupport(date.getDate());
			var hh = timeSupport(date.getHours());
			var mi = timeSupport(date.getMinutes());
			var ss = timeSupport(date.getSeconds());
			var returnDate = yy + '-' + mm + '-'  + dd + ' ' + hh + ':' + mi + ':' + ss;

			return returnDate;
		};

		var changeNumber = function(data) {
			return (data == null) ? 0:data;
		};

		//상태값 초기화
		statusKwd = {};
		if(0 < listKeys.length) {
			for (var i = 0; i < listKeys.length; i++) {

				var curBtnId = '"#cur-save-btn-' + i + '"';
				var maxBtnId = '"#max-save-btn-' + i + '"';
				var minBtnId = '"#min-save-btn-' + i + '"';
				var goalBtnId = '"#goal-save-btn-' + i + '"';

				var msgActive = function(off) {
					return (listValues[i].msg_cd == off) ? 'point':'';
				};
				var activeClass = ((listValues[i].bid_status != 'Inactive') && (listValues[i].cur_bid_amt >= listValues[i].max_bid_amt)) ? 'point':(listValues[i].cur_bid_amt <= listValues[i].min_bid_amt) ? 'point2':'';
				var activeComment = ((listValues[i].bid_status != 'Inactive') && (listValues[i].cur_bid_amt >= listValues[i].max_bid_amt)) ? '자동입찰의 최대입찰가에 도달하였습니다.':(listValues[i].cur_bid_amt <= listValues[i].min_bid_amt) ? '자동입찰의 최소입찰가에 도달하였습니다.':'';
				var target = (listValues[i].target == null) ? '동기화요청':(listValues[i].target == 'all') ? '전체':listValues[i].target;
				var goalMaxRank = (target == 'mobile') ? 15:25;

				//null일경우 0으로 반환 (추가시 changeKey에 키값 추가)
				var changeKey = ['cur_cpa_amt','rec_clk_rnk','cur_opp_rank','opp_gap','goal_cpa_amt','min_bid_amt','rank','rank_range','cur_opp_rank'];
				for(var idx = 0; idx < changeKey.length; idx++) {
					listValues[i][changeKey[idx]] = changeNumber(listValues[i][changeKey[idx]]);
				}

				statusKwd[listValues[i].kwd_id] = listValues[i].kwd_id;


				///////////
				//고정 테이블 //
				///////////
				listHtml1 += "<tr class='" + listValues[i].kwd_id + "' data-id='" + listValues[i].kwd_id + "'>";
				listHtml1 += 	"<td><input type='checkbox' class='list-check' id='campaign" + i + "' onclick='favoriteFunc.favoriteBtnOnOffEvent();'><label for='campaign" + i + "'></label></td>";
				listHtml1 += 	"<td>";
				listHtml1 += 		"<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
				listHtml1 += 			"<button type='button' data-name='status' data-status='ELIGIBLE' data-type='status' class='status-on' onclick='favoriteFunc.favoriteBidChangeData(this);'>ON</button>";
				listHtml1 += 			"<button type='button' data-name='status' data-status='PAUSED' data-type='status' class='status-off on' onclick='favoriteFunc.favoriteBidChangeData(this);'>OFF</button>";
				listHtml1 += 		"</div>";
				listHtml1 += 	"</td>";
				listHtml1 += 	"<td>" + target + "</td>";
				listHtml1 += 	"<td align='left'>" + listValues[i].campaign_nm + "</td>";
				listHtml1 += 	"<td align='left'><span class='group-td " + msgActive('group_off') + "' data-comment='광고그룹 OFF'>" + listValues[i].adgroup_nm + "</span></td>";
				listHtml1 += 	"<td class='keyword_contents'>";
				if(target == 'mobile') {
					listHtml1 += 		"<a href='https://m.search.naver.com/search.naver?query=" + listValues[i].kwd_nm +"' target='_blank'></a>";
				}else{
					listHtml1 += 		"<a href='https://search.naver.com/search.naver?&query=" + listValues[i].kwd_nm +"' target='_blank'></a>";
				}
				listHtml1 += 		"<div class='update-time'>";
				listHtml1 += 			"<span class='date-text'><div class='kwd-td" + msgActive('kwd_off') + "' data-comment='키워드 OFF'>" + listValues[i].kwd_nm + "</div></span>";
				listHtml1 += 			"<span class='time-icon'><img src='/image/common/keyword_watch.png' alt='시계아이콘'></span>";
				listHtml1 += 			"<p class='time-text'>" + times(listValues[i].updated_at);+ "</p>";
				listHtml1 += 		"</div>";
				listHtml1 += 	"</td>";
				listHtml1 += "</tr>";

				///////////////
				//이동 스크롤 테이블 //
				///////////////
				listHtml2 += "<tr class='" + listValues[i].kwd_id + "' data-id='" + listValues[i].kwd_id + "'>";
				//현재순위
				listHtml2 += 	"<td>" + listValues[i].rank + "/" + listValues[i].rank_range + "</td>";


				//현재 입찰가
				listHtml2 += 	"<td>";
				listHtml2 += 		"<div class='bid_wrap'>";
				listHtml2 += 			"<div class='bid_icon'>";
				if(listValues[i].bid_status == 'Inactive') {
					listHtml2 += 				"<button type='button' class='bid_01 bid-cur-option bidPop_btn' data-name='bidFavorite' data-key='" + listValues[i].kwd_id + "' onclick='layerPopup.open(this, this.id);'></button>";
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-cur-option'></button>";
				}else{
					listHtml2 += 				"<button type='button' class='bid_01 bid-cur-option' disabled></button>";
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-cur-option' disabled></button>";
				}
				listHtml2 += 			"</div>";
				listHtml2 += 			"<div class='bid_price cur_bid_price " + activeClass + "' data-comment='" + activeComment + "'>" + numberWithCommas(listValues[i].cur_bid_amt) + "</div>";
				listHtml2 += 			"<div class='active-btn-area hide'>";
				listHtml2 += 				"<form onsubmit='favoriteFunc.favoriteBidChangeData(" + curBtnId + "); return false;'>"
				listHtml2 +=					"<button id='cur-save-btn-" + i + "' type='button' data-type='curBid' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
				listHtml2 += 					"<button type='button' class='list-btn-cancer'>취소</button>";
				listHtml2 += 					"<input type='number' name='cur_bid_amt' value='" + listValues[i].cur_bid_amt + "' class='bid-cur-input active-input-area'>";
				listHtml2 += 				"</form>";
				listHtml2 += 			"</div>";
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";


				//입찰유형
				listHtml2 += 	"<td class='bidStatus-td'>";
				if(listValues[i].bid_status == 'Inactive') {
					listHtml2 += 			"<p data-status='Inactive'>수동</p>";
				}else if(listValues[i].bid_status == 'CpaActive') {
					listHtml2 += 			"<p data-status='" + listValues[i].bid_status + "'>목표CPA</p>";
				}else if(listValues[i].bid_status == 'OppActive') {
					listHtml2 += 			"<p data-status='" + listValues[i].bid_status + "'>경쟁사 타겟</p>";
				}else{
					listHtml2 += 			"<p data-status='" + listValues[i].bid_status + "'>목표순위</p>";
				}
				listHtml2 += 	"</td>";

				//최대 입찰가
				listHtml2 += 	"<td>";
				listHtml2 += 		"<div class='bid_wrap'>";
				listHtml2 += 			"<div class='bid_icon'>";
				if(listValues[i].bid_status == 'Inactive') {
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-max-option' disabled></button>";
				}else{
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-max-option'></button>";
				}
				listHtml2 += 			"</div>";
				listHtml2 += 			"<div class='bid_price max_bid_price'>" + numberWithCommas(listValues[i].max_bid_amt) + "</div>";
				listHtml2 += 			"<div class='active-btn-area hide'>";
				listHtml2 += 				"<form onsubmit='favoriteFunc.favoriteBidChangeData("+ maxBtnId +"); return false;'>";
				listHtml2 +=					"<button id='max-save-btn-" + i + "' type='button' data-type='bidMax' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
				listHtml2 += 					"<button type='button' class='list-btn-cancer'>취소</button>";
				listHtml2 += 					"<input type='number' name='max_bid_amt' value='" + listValues[i].max_bid_amt + "' class='bid-max-input active-input-area'>";
				listHtml2 += 				"</form>";
				listHtml2 += 			"</div>";
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";

				//최소 입찰가 설정
				listHtml2 += 	"<td>";
				listHtml2 += 		"<div class='bid_wrap'>";
				listHtml2 += 			"<div class='bid_icon'>";
				if(listValues[i].bid_status == 'Inactive') {
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-min-option' disabled></button>";
				}else{
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-min-option'></button>";
				}
				listHtml2 += 			"</div>";
				listHtml2 += 			"<div class='bid_price min_bid_price'>" + numberWithCommas(listValues[i].min_bid_amt) + "</div>";
				listHtml2 += 			"<div class='active-btn-area hide'>";
				listHtml2 += 				"<form onsubmit='favoriteFunc.favoriteBidChangeData("+ minBtnId +"); return false;'>";
				listHtml2 +=					"<button id='min-save-btn-" + i + "' type='button' data-type='bidMin' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
				listHtml2 += 					"<button type='button' class='list-btn-cancer'>취소</button>";
				listHtml2 += 					"<input type='number' name='min_bid_amt' value='" + listValues[i].min_bid_amt + "' class='bid-min-input active-input-area'>";
				listHtml2 += 				"</form>";
				listHtml2 += 			"</div>";
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";

				//목표순위 자동입찰
				listHtml2 += 	"<td class='add-td-1'>";
				listHtml2 += 		"<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
				if(listValues[i].bid_status == 'Active') {
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on bid-status-btn bid-status-active bid-status-btns'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' class='bid-status-btn bid-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
				}else{
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' class='bid-status-btn bid-status-active bid-status-btns' data-name='bid_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on bid-status-btn bid-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
				}
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";

				//입찰 성공률
				// listHtml2 += 	"<td class='add-td-1'>" + listValues[i].bid_success_rate + "%</td>";

				listHtml2 += 	"<td class='add-td-1'>";
				if (listValues[i].bid_status != 'Active') {
					listHtml2 += 	"<select class='bid-rank-option' data-name='goal_rank' data-rank='" + listValues[i].goal_rank + "' data-type='bidRank' disabled onchange='favoriteFunc.favoriteBidChangeData(this);'>";
				}else{
					listHtml2 += 	"<select class='bid-rank-option' data-name='goal_rank' data-rank='" + listValues[i].goal_rank + "' data-type='bidRank' onchange='favoriteFunc.favoriteBidChangeData(this);'>";
				}
				for(var idx = 1; idx <= goalMaxRank; idx++) {
					if(listValues[i].goal_rank == idx) {
						listHtml2 += 		"<option value='" + idx + "' selected>" + idx + "</option>";
					}else{
						listHtml2 += 		"<option value='" + idx + "'>" + idx + "</option>";
					}
				}
				listHtml2 += 		"</select>";
				if(listValues[i].rank_var_status == 'saved') {
					listHtml2 += 		"<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rate' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='증감률아이콘'></button>";
				}else{
					listHtml2 += 		"<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rate' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='증감률아이콘'></button>";
				}
				// if((listValues[i].bid_status != 'CpaActive' && listValues[i].bid_status != 'Inactive') && (listValues[i].rank_range < listValues[i].goal_rank)) {
				// 	listHtml2 += 	"<div class='comment-box'>";
				// 	listHtml2 += 		"<span class='rank-ms-icon'><img src='/image/common/alert_icon.png' alt='크롤링 실패'></span>";
				// 	listHtml2 += 		"<div class='comment-inner hide'>";
				// 	listHtml2 += 			"<p class='comment-text'>더보기 영역 입찰불가. 자동입찰중지됨.</p>";
				// 	listHtml2 += 		"</div>";
				// 	listHtml2 += 	"</div>";
				// }
				listHtml2 += 	"</td>";

				//목표 CPA 자동입찰
				listHtml2 += 	"<td class='add-td-2'>";
				listHtml2 += 		"<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
				if(listValues[i].bid_status == 'CpaActive') {
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='CpaActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on cpa-status-btn cpa-status-active bid-status-btns'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' class='cpa-status-btn cpa-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
				}else{
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' class='cpa-status-btn cpa-status-active bid-status-btns' data-name='bid_status' data-status='CpaActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on cpa-status-btn cpa-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
				}
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";

				listHtml2 += 	"<td class='add-td-2'>";
				listHtml2 += 		"<span>" + numberWithCommas(listValues[i].cur_cpa_amt) + "</span>";
				if(listValues[i].msg_cd == 'cpa_shortage') {
					listHtml2 += 	"<span class='alert-icon comment-alert' data-comment='CPA산출데이터 불충분.<br/> 일 평균 클릭, 전환 10회 미만으로<br/> CPA입찰 시 불안정할 수 있음'><img src='/image/common/alert_icon.png' alt='느낌표'></span>";
				}
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td class='add-td-2 keyword_contents keywords_hover'>";
				listHtml2 += 		"<div class='update-time time-2'>";
				listHtml2 += 			"<span class='clk-text'>" + listValues[i].rec_clk_rnk + "</span>";
				listHtml2 += 			"<p class='time-text'>" + times(listValues[i].rec_clk_at) + "</p>";
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td class='add-td-2'>";
				listHtml2 += 		"<div class='bid_wrap'>";
				listHtml2 += 			"<div class='bid_icon'>";
				if(listValues[i].bid_status != 'CpaActive') {
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-cpa-option' disabled></button>";
				}else{
					listHtml2 += 				 "<button type='button' class='bid_02 list-btn-modify bid-cpa-option'></button>";
				}
				listHtml2 += 			"</div>";
				listHtml2 += 			"<div class='bid_price goal_cpa_price'>" + numberWithCommas(listValues[i].goal_cpa_amt) + "</div>";
				listHtml2 += 			"<div class='active-btn-area hide'>";
				listHtml2 += 				"<form onsubmit='favoriteFunc.favoriteBidChangeData("+ goalBtnId +"); return false;'>";
				listHtml2 +=					"<button id='goal-save-btn-" + i + "' type='button' data-type='goalCpa' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
				listHtml2 += 					"<button type='button' class='list-btn-cancer'>취소</button>";
				listHtml2 += 					"<input type='number' name='goal_cpa_amt' value='" + listValues[i].goal_cpa_amt + "' class='bid-max-input active-input-area'>";
				listHtml2 += 				"</form>";
				listHtml2 += 			"</div>";
				if(listValues[i].cpa_var_status == 'saved') {
					listHtml2 += 			"<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rateCpa' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='증감률아이콘'></button>";
				}else{
					listHtml2 += 			"<button type='button' class='rate_btn' data-key='" + listValues[i].kwd_id + "' data-name='rateCpa' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='증감률아이콘'></button>";
				}
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";


				//경쟁사 타겟 자동입찰
				listHtml2 += 	"<td class='add-td-3'>";
				listHtml2 += 		"<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
				if(listValues[i].bid_status == 'OppActive') {
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='OppActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on opp-status-btn opp-status-active bid-status-btns'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' class='opp-status-btn opp-status-Inactive bid-status-btns bid-status-Inactives' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
				}else{
					listHtml2 += 			"<button id='check2-bidStatus' data-type='bidStatus' class='opp-status-btn opp-status-active bid-status-btns' data-name='bid_status' data-status='OppActive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
					listHtml2 += 			"<button id='check-bidStatus' data-type='bidStatus' data-name='bid_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on opp-status-btn opp-status-Inactive bid-status-btns bid-status-Inactives'>OFF</button>";
				}
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td class='add-td-3'>";
				if(listValues[i].opp_site === null) {
					listHtml2 += 	"<span class='opp-rank'>미등록</span>";
				}else{
					if(listValues[i].cur_opp_rank === 16){
						listHtml2 += 	"<span class='opp-rank'><img src='/image/common/alert_icon.png' alt='크롤링 실패'></span>";
					}else{
						listHtml2 += 	"<span class='opp-rank'>" + listValues[i].cur_opp_rank + "</span>/<span class='opp-gap'>" + listValues[i].rank_range + "</span>";
					}
				}
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td class='add-td-3'>";
				if(listValues[i].bid_status == 'OppActive') {
					listHtml2 += 		"<button type='button' class='his_btn target_btn' data-key='" + listValues[i].kwd_id + "' data-name='target' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/target_icon.png' alt='타겟아이콘'></button>";
				}else{
					listHtml2 += 		"<button type='button' class='his_btn target_btn' data-key='" + listValues[i].kwd_id + "' data-name='target' data-id='favorite-area' onclick='layerPopup.open(this);' disabled><img src='/image/common/target_icon.png' alt='타겟아이콘'></button>";
				}
				listHtml2 += 	"</td>";

				//예약
				listHtml2 += 	"<td class='add-td-4'>";
				listHtml2 += 		"<div class='on_off_btn status-btn-area status-ui-btn" + i + "'>";
				if(listValues[i].resv_status == 'Active') {
					listHtml2 += 			"<button id='check2-resvStatus' data-type='resvStatus' data-name='resv_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on resv-status-btn resv-status-active'>ON</button>";
					listHtml2 += 			"<button id='check-resvStatus' data-type='resvStatus' class='resv-status-btn resv-status-Inactive bid-status-Inactives' data-name='resv_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>OFF</button>";
				}else{
					listHtml2 += 			"<button id='check2-resvStatus' data-type='resvStatus' class='resv-status-btn resv-status-active bid-status-btns' data-name='resv_status' data-status='Active' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button'>ON</button>";
					listHtml2 += 			"<button id='check-resvStatus' data-type='resvStatus' data-name='resv_status' data-status='Inactive' onclick='favoriteFunc.favoriteBidChangeData(this);' type='button' class='on resv-status-btn resv-status-Inactive bid-status-Inactives'>OFF</button>";
				}
				listHtml2 += 		"</div>";
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td class='add-td-4'>";
				if(listValues[i].schedule_status == 'saved') {
					listHtml2 += 		"<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='booking' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn_on.png' alt='예약아이콘'></button>";
				}else{
					listHtml2 += 		"<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='booking' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/book_btn.png' alt='예약아이콘'></button>";
				}
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td>";
				listHtml2 += 		"<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='history' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/history_icon.png' alt='이력아이콘'></button>";
				listHtml2 += 	"</td>";
				listHtml2 += 	"<td>";
				listHtml2 += 		"<button type='button' class='his_btn' data-key='" + listValues[i].kwd_id + "' data-name='chart1' data-id='favorite-area' onclick='layerPopup.open(this);'><img src='/image/common/chart_icon.png' alt='통계아이콘'></button>";
				listHtml2 += 	"</td>";
				listHtml2 += "</tr>";
			}
			//적용
			$count .text(listKeys.length);
			$list.show();
			$noList.hide();
		}else{
			$count.text(0);
			$('.none_date p').text('키워드 이력이 없습니다.');
			$list.hide();
			$noList.show();
		}
		if(subCheck == true) {
			$search.show();
		}else{
			$search.hide();
		}
		$listBodyPos.html(listHtml1);
		$listBodyFull.html(listHtml2);
		//상태값 온오프
		favoriteFunc.favoriteListStatusData(statusKwd);
		favoriteFunc.favoriteListBidEvent();
		favoriteFunc.favoriteBtnOnOffEvent();
	},
	favoriteBtnOnOffEvent:function() {
		if( $('.list-check:checked').length == 0 ){
			$('.check-btn').prop('disabled',true);
		}else{
			$('.check-btn').prop('disabled',false);
		}
	},
	//즐겨찾기 리스트 입찰 이벤트
	favoriteListBidEvent:function() {
		var subEl = '.favorite_inner_table_wrap tbody tr';
		$(subEl).find('.list-btn-modify').click(function() {
			var $this = $(this);
			$(subEl).find('.bid_icon').show();
			$(subEl).find('.bid_price').show();
			$(subEl).find('.active-btn-area').hide();
			$this.parent().hide();
			$this.parent().next().hide();
			$this.parent().parent().find('.active-btn-area').show();
		});
		$(subEl).find('.list-btn-cancer').click(function() {
			var $this = $(this);
			var prevText = $this.parents('.bid_wrap').find('.bid_price').text();
			$(subEl).find('.bid_icon').show();
			$(subEl).find('.bid_price').show();
			$(subEl).find('.active-btn-area').hide();
			$this.parents('.bid_wrap').find('.active-input-area').val(uncomma(prevText));
		});
		//이력 이벤트 키워드
		$('.his_btn, .bidPop_btn').click(function() {
			var thisKey = $(this).attr('data-key');
			historyKey = thisKey;
		});
		//입찰가 맥스값 도달 ON 호버 처리
		$('.cur_bid_price.point,.cur_bid_price.point2,.group-td.point,.kwd-td.point,.comment-alert').mouseenter(function() {
			var comment = $(this).attr('data-comment');
			var html = "<div class='max-point-box'>";
			html += 	"<p class='text-p'>" + comment + "</p>";
			html += 	"</div>";
			$(this).append(html);
		}).mouseleave(function() {
			$(this).find('.max-point-box').remove();
		});
	},
	//즐겨찾기 등록 키워드
	favoriteGroupKeywordCallBack:function(data) {
		groupKeyword = data.data;
	},
	//즐겨찾기 키워드 팝업
	favoriteKeywordPopCallBack:function() {
		//생성된 객체를 초기화 함
		keywordData = {};
		addKeywordData = {};
		pushKeywordData = {};
		$('.fixed-pop').fadeIn(200);
		favoriteFunc.favoriteAddKeywordListData(advKey);
		//광고주 키워드 등록 리스트
		favoriteFunc.favoriteGroupKeywordData();
	},
	//즐겨찾기 운영 키워드
	favoriteKeywordCallBack:function(data) {
		var dataCheck = Object.keys(data);
		var $ul = $('.keyword-list-inner');
		var html = '';
		var $count = $('#oper-count');
		if(dataCheck[0] == 'data'){
			keywordData = data.data;
			var dataKey = Object.keys(keywordData);
			var dataValue = dataKey.map(function(i) {
				return keywordData[i];
			});
			if(0 < dataKey.length) {
				for(var i = 0; i < dataKey.length; i++) {
					html += "<li class='" + dataKey[i] + "''>";
					html += 	"<div>";
					if(addKeywordData[dataKey[i]] == dataKey[i]) {
						html += 		"<input type='checkbox' class='keyword-list-check' checked value='"+ dataKey[i] + "' id='keyword" + i + "' onchange='favoriteFunc.favoriteKeywordAddCallBack(this);'>";
					}else{
						html += 		"<input type='checkbox' class='keyword-list-check' value='"+ dataKey[i] + "' id='keyword" + i + "' onchange='favoriteFunc.favoriteKeywordAddCallBack(this);'>";
					}
					html += 		"<label for='keyword" + i + "'>";
					html += 			"<span class='keyword-name'>"+dataValue[i].kwd_nm+"</span><span class='keyword-groups'>(" + advNm + " > " + dataValue[i].campaign_nm + " > " +  dataValue[i].adgroup_nm + ")</span>";
					if(groupKeyword[dataKey[i]] != undefined) {
						html += 		"<span class='group-nm'>(" + groupKeyword[dataKey[i]] + ")</span>";
					}
					html += 		"</label>";
					html += 	"</div>";
					html +=  "</li>";
					if( i == 1000 ){
						break;
					}
				}
				$ul.html(html);
				$count.text(dataKey.length);
			}else{
				alert('관련 키워드가 없습니다.');
				html += "<li class='keyword-comment'>검색된 키워드가 없습니다.</li>";
				$ul.html(html);
				$count.text(0);
			}
		}else{
			alert('관련 키워드가 없습니다.');
			html += "<li class='keyword-comment'>검색된 키워드가 없습니다.</li>";
			$ul.html(html);
			$count.text(0);
		}
	},
	//즐겨찾기 운영 키워드 추가
	favoriteKeywordAddCallBack:function(thisEl) {
		var $ul = $('.keyword-list-inner');
		var $addUl = $('.add-keyword-inner');
		var html = '';
		var $this = $(thisEl);
		var thisCheck = $this.prop('checked');
		var keywordKey = $this.val();
		var $count = $('#add-count');
		var addCount = $count.text();

		if(thisCheck == true) {
			html += "<li class='" + keywordKey + "'>";
			html += 	"<div class='add-keyword-box'>";
			html += 		"<span class='keyword-name'>"+ keywordData[keywordKey].kwd_nm +"</span><span class='keyword-groups'>(" + advNm + " > "+ keywordData[keywordKey].campaign_nm +" > " + keywordData[keywordKey].adgroup_nm + ")</span>";


			if(groupKeyword[keywordKey] != undefined) {
				html += 	"<span class='group-nm'>(" + groupKeyword[keywordKey] + ")</span>";

			}


			html += 		"<button type='button' class='delete-btn' onclick='favoriteFunc.favoriteKeywordDeleteCallBack(this);'>X</button>";
			html += 	"</div>";
			html +=  "</li>";
			//추가 리스트 카운트 증가
			addCount++;
			$count.text(addCount);
			//추가삭제 종합
			addKeywordData[keywordKey] = keywordKey;
			//추가된 키워드 저장
			pushKeywordData[keywordKey] = {
				"ad_med_id":1,
				"campaign_id":keywordData[keywordKey].campaign_id,
				"campaign_nm":keywordData[keywordKey].campaign_nm,
				"adgroup_id":keywordData[keywordKey].adgroup_id,
				"adgroup_nm":keywordData[keywordKey].adgroup_nm,
				"kwd_id":keywordKey,
				"kwd_nm":keywordData[keywordKey].kwd_nm,
				"cur_bid_amt":keywordData[keywordKey].bid_amt
			};
		}else{
			//추가 리스트 카운트 감소
			addCount--;
			$count.text(addCount);
			//추가된 키워드 삭제
			delete addKeywordData[keywordKey];
			//추가된 키워드 저장
			delete pushKeywordData[keywordKey];
			$addUl.find('.' + keywordKey).remove();
		}
		$addUl.find('.keyword-comment').remove();
		$addUl.append(html);
	},
	//즐겨찾기 추가 키워드 삭제
	favoriteKeywordDeleteCallBack:function(thisEl) {
		var $count = $('#add-count');
		var addCount = $count.text();
		var keywordKey = $(thisEl).parents('li').attr('class');

		//추가 리스트 카운트 감소
		addCount--;
		$count.text(addCount);
		//삭제된 키워드 제거
		delete addKeywordData[keywordKey];
		delete pushKeywordData[keywordKey];

		$(thisEl).parents('li').remove();
		$('.' + keywordKey).find('input').prop('checked', false);
	},
	//즐겨찾기 신규 키워드1
	favoriteAddKeywordListCallBack:function(data) {
		var dataFilter = data.data;
		var html = '';
		var addList = '#add-keyword-list-1';
		var $count = $('#new-cam-count');
		if(0 < dataFilter.length) {
			for(var i = 0; i < dataFilter.length; i++) {
				html += "<li><a href='javascript:void(0);' data-id='" + dataFilter[i].nccCampaignId + "' onclick='javascript:favoriteFunc.favoriteAddKeywordListData2(this);'>" + dataFilter[i].name + "</a></li>";
				addKeywordData[dataFilter[i].nccCampaignId] = dataFilter[i].name;
			}

			$count.text(dataFilter.length);
		}else{
			html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";

			$count.text(0);
		}
		$(addList).find('ul').html(html);
		keywordPopActive(addList);
	},
	//즐겨찾기 신규 키워드2
	favoriteAddKeywordList2CallBack:function(data) {
		var dataFilter = data.data;
		var html = '';
		var addList = '#add-keyword-list-2';
		var addList3 = '#add-keyword-list-3';
		var $count = $('#new-group-count');
		var addHtml3 = "<li class='keyword-comment'>광고그룹을 선택하세요.</li>";
		if(0 < dataFilter.length) {
			for(var i = 0; i < dataFilter.length; i++) {
				html += "<li><a href='javascript:void(0);' data-id='" + dataFilter[i].nccAdgroupId + "' onclick='javascript:favoriteFunc.favoriteAddKeywordListData3(this);'>" + dataFilter[i].name + "</a></li>";
				addKeywordData[dataFilter[i].nccAdgroupId] = dataFilter[i].name;
			}

			$count.text(dataFilter.length);
		}else{
			html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";

			$count.text(0);
		}
		$(addList).find('ul').html(html);
		$(addList3).find('ul').html(addHtml3);
		keywordPopActive(addList);
	},
	//즐겨찾기 신규 키워드3
	favoriteAddKeywordList3CallBack:function(data) {
		var dataFilter = data.data;
		var newKeywordKey = Object.keys(dataFilter);
		var html = '';
		var temp_obj = {};
		var addList = '#add-keyword-list-3';
		var $count = $('#new-key-count');
		var listFilterData = {};
		var $bidListTr = $('#bid-list-body-2 tr');

		//중복 데이터 필터
		$bidListTr.each(function() {
			var listKeywordCheck = $(this).attr('data-id');
			listFilterData[listKeywordCheck] = true;
		});

		if(0 < newKeywordKey.length) {
			newKeywordKey.map(function(key) {
				temp_obj[dataFilter[key].keyword] = dataFilter[key];
			});
			var newTempKeywordKey = Object.keys(temp_obj);
			newTempKeywordKey.sort();
			for(var i = 0; i < newTempKeywordKey.length; i++) {
				var _nccKeywordId = temp_obj[newTempKeywordKey[i]].nccKeywordId;
				var _keyword = temp_obj[newTempKeywordKey[i]].keyword;
				var _compare_nccKeywordId = addKeywordData[_nccKeywordId];
				var _keywordBid = temp_obj[newTempKeywordKey[i]].bidAmt;
				var _overlapData = (listFilterData[_nccKeywordId] == true) ? '(추가완료)':'';
				html += "<li class='" + _nccKeywordId + "'>";
				html += 	"<div>";
				if(_compare_nccKeywordId == _nccKeywordId) {
					html += 		"<input type='checkbox' id='add-keyword-" + i + "'  data-name='" + _keyword + "' data-id='" + _nccKeywordId+ "' checked onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
				}else if(listFilterData[_nccKeywordId] == true) {
					html += 		"<input type='checkbox' id='add-keyword-" + i + "' disabled  data-name='" + _keyword + "' data-bid='" + _keywordBid + "' data-id='" + _nccKeywordId + "' onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
				}else{
					html += 		"<input type='checkbox' id='add-keyword-" + i + "'  data-name='" + _keyword + "' data-bid='" + _keywordBid + "' data-id='" + _nccKeywordId + "' onchange='favoriteFunc.favoriteAddKeywordCallBack(this);'>";
				}
				html += 		"<label for='add-keyword-" + i + "'>" + _keyword + "<span style='color:red;'>" + _overlapData + "</span>" + "</label>";
				html +=	"</div>";
				html += "</li>";
			}
			$count.text(newKeywordKey.length);
		}else{
			html += "<li class='keyword-comment'>해당 항목이 없습니다.</li>";
			$count.text(0);
		}
		$(addList).find('ul').html(html);
		keywordPopActive(addList);
	},
	//즐겨찾기 신규 키워드 추가
	favoriteAddKeywordCallBack:function(thisEl) {
		var $this = $(thisEl);
		var $ul = $('.keyword-list-inner');
		var $addUl = $('.add-keyword-inner');
		var camId = $('#add-keyword-list-1').find('.active').attr('data-id');
		var groupId = $('#add-keyword-list-2').find('.active').attr('data-id');
		var keywordId = $this.attr('data-id');
		var keyText = $this.attr('data-name');
		var keyBid = $this.attr('data-bid');
		var html = '';
		var thisCheck = $this.prop('checked');
		var $count = $('#add-count');
		var addCount = $count.text();
		if(thisCheck == true) {
			html += "<li class='" + keywordId + "'>";
			html += 	"<div class='add-keyword-box'>";
			html += 		"<span class='keyword-name'>"+ keyText +"</span><span class='keyword-groups'>(" + advNm + " > "+ addKeywordData[camId] +" > " + addKeywordData[groupId] + ")</span>";

			if(groupKeyword[keywordId] != undefined) {
				html += 	"<span class='group-nm'>(" + groupKeyword[keywordId] + ")</span>";

			}
			html += 		"<button type='button' class='delete-btn' onclick='favoriteFunc.favoriteKeywordDeleteCallBack(this);'>X</button>";
			html += 	"</div>";
			html +=  "</li>";

			//추가 리스트 카운트 증가
			addCount++;
			$count.text(addCount);
			//추가삭제 종합
			addKeywordData[keywordId] = keywordId;
			//추가된 키워드 저장

			pushKeywordData[keywordId] = {
				"ad_med_id":1,
				"campaign_id":camId,
				"campaign_nm":addKeywordData[camId],
				"adgroup_id":groupId,
				"adgroup_nm":addKeywordData[groupId],
				"kwd_id":keywordId,
				"kwd_nm":keyText,
				"cur_bid_amt":keyBid
			};
		}else{
			//추가 리스트 카운트 증가
			addCount--;
			$count.text(addCount);
			//추가된 키워드 삭제
			delete addKeywordData[keywordId];
			delete pushKeywordData[keywordId];
			$addUl.find('.' + keywordId).remove();
		}
		$addUl.find('.keyword-comment').remove();
		$addUl.append(html);
	},

	//즐겨찾기 팝업 데이터 변경 콜백
	favoriteChangeCallBack:function() {
		layerPopup.close();
		$('#timeLoading').remove();
	},

	//즐겨찾기 키워드 이동 콜백
	favoriteKeywordPushCallBack:function(result) {
		if(result.data == 'OVER_BY_ADV_ID') {
			alert('광고주별 최대 즐겨찾기 개수를 초과하였습니다.');
		}else if(result.data == 'OVER_BY_ALL') {
			alert('입찰 솔루션에 등록 가능한 즐겨찾기 갯수가 초과하였습니다.');
		}else{
			var moveSubId = $('#move-group-select').val();
			layerPopup.close();
			if(moveSubId != null) {
				alwaysFunc.asideMenuSubData(advId, 'subMenu');
				setTimeout(function() {
					$(groupSubId).val(moveSubId);
					favoriteFunc.favoriteSubListData(moveSubId);
					$(groupSubId).val(moveSubId);
					$('.menu-sub-inner li a').removeClass('active');
					$('.menu-sub-inner').find('.' + moveSubId + ' a').addClass('active');
				}, 1000);
			}else{
				alwaysFunc.asideMenuSubData(advId, 'subMenu');
				setTimeout(function() {
					$(groupSubId).val(advSubId);
					favoriteFunc.favoriteSubListData(advSubId);
					$('.menu-sub-inner li a').removeClass('active');
					$('.menu-sub-inner').find('.' + advSubId + ' a').addClass('active');
				}, 1000);
			}
		}
	},

	//즐겨찾기 상태 값 콜백
	favoriteStatusCallBack:function(data) {
		statusData = data.data;
		var statusKey = Object.keys(statusData);
		var statusValue = statusKey.map(function(key) {
			return statusData[key]
		});
		if(0 < statusKey.length) {
			for (var i = 0; i < statusKey.length; i ++) {
				var statusCheck = statusValue[i].status;
				faListData[statusKey[i]]['status'] = statusCheck;
				$('.' + statusKey[i]).find('.on_off_btn .status-off, .status-on').removeClass('on');
				if(statusCheck != 'PAUSED') {
					$('.table-list-body .' + statusKey[i]).find('.status-on').addClass('on');
				}else{
					$('.table-list-body .' + statusKey[i]).find('.status-off').addClass('on');
				}
			}
		}
	},

	//즐겨찾기 키워드 이동 팝업 콜백
	favoriteKeywordMoveGroupCallBack:function(data, checkData) {
		var dataFilter = data.groups;
		var dataKey = Object.keys(dataFilter);
		var dataValue = dataKey.map(function(key) {
			return dataFilter[key];
		});
		var $select = $('#move-group-select');
		var $list = $('#move-keyword-list');
		var $count = $('#move-keyword-count');
		var html = '';
		var keywordHtml = '';
		if(0 < dataKey.length) {
			html += "<option value=''>선택</option>";
			for (var i = 0; i < dataKey.length; i++) {
				html += "<option value='" + dataValue[i].id + "'>" + dataValue[i].name + "</option>";
			}
		}else{
			html += "<option value=''>그룹이 없습니다.</option>";
		}

		if(0 < checkData.length) {
			for(var i = 0; i < checkData.length; i++) {
				keywordHtml += "<li class='" + checkData[i].kwd_id + "'>";
				keywordHtml += 	"<div>";
				keywordHtml += 		"<button type='button' data-id='" + checkData[i].kwd_id + "' onclick='favoriteFunc.favoriteMoveKeywordDelete(this);'><img src='image/common/bid_icon_04.png' alt='삭제''></button>";
				keywordHtml += 	"</div>";
				keywordHtml += 	"<div>" + checkData[i].kwd_nm + " ( "+ advNm + ' > ' + checkData[i].campaign_nm + ' > ' + checkData[i].adgroup_nm + " )</div>";
				keywordHtml +=  "</li>";
				moveKeywordData[checkData[i].kwd_id] = {
					"ad_med_id" : "1",
					"campaign_id" : checkData[i].campaign_id,
					"campaign_nm" : checkData[i].campaign_nm,
					"adgroup_id" : checkData[i].adgroup_id,
					"adgroup_nm" : checkData[i].adgroup_nm,
					"kwd_id" : checkData[i].kwd_id,
					"kwd_nm" : checkData[i].kwd_nm,
					"cur_bid_amt":checkData[i].cur_bid_amt
				}
			}
		}else{
			keywordHtml +=  "<li>선택된 키워드가 없습니다.</li>";
		}
		$select.html(html);
		$list.html(keywordHtml);
		$count.text(checkData.length);
		$('.fixed-pop').fadeIn(200);
	},

	//즐겨찾기 키워드 이동 선택 삭제
	favoriteMoveKeywordDelete:function(thisEl) {
		if(confirm("삭제하시겠습니까?") == true) {
			var $this = $(thisEl);
			var removeData = $this.attr('data-id');
			delete moveKeywordData[removeData];
			$this.parents('li').remove();
		}
	},
	//즐겨찾기 테이블 제어 필터 콜백
	favoriteFilterCallBack:function(data, key) {
		//필터 소팅용(가나다순)
		var ascending = function(a,b) {
	        var a = a.toString().toLowerCase();
	        var b = b.toString().toLowerCase();
	        return ( a < b ) ? -1 : ( a == b ) ? 0 : 1;
		};
		//필터 소팅용(역순)
		var descending = function(a,b) {
	        var a = a.toString();
	        var b = b.toString();
	        return b.localeCompare(a);
		};
		var dataKey = Object.keys(data).sort().sort(ascending);
		var dataKey = (key == 'bid_status_c') ? dataKey.sort(descending):dataKey;
		var html = '';
		var ulArray = ['#status-view-ul','#target-view-ul','#campaign-view-ul','#group-view-ul','#bidstatus-view-ul','#bidstatus-view-ul-a','#bidstatus-view-ul-b','#bidstatus-view-ul-c','#sStatus-view-ul'];
		var keyArray = ['status','target','campaign_nm','adgroup_nm','bid_status','bid_status_a','bid_status_b','bid_status_c','resv_status'];
		var filterKey = Object.keys(filterCheckSave);
		var check = false;

		var listHtml = function(i, textType, checks) {
			var checking = (checks == true) ? 'checked':'';
			if(textType == 'PAUSED' || textType == 'Active' || textType == 'CpaActive' || textType == 'OppActive') {
				var textFilter = (dataKey[i] == textType) ? 'ON':'OFF';
				if(dataKey[i] == textType) {
					html += "<li><input type='checkbox' id='"+ keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='"+ keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
				}else if(dataKey[i] == 'Inactive') {
					html += "<li><input type='checkbox' id='"+ keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='"+ keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
				}
			}else{
				var textFilter = (dataKey[i] == 'Active') ? '목표순위':(dataKey[i] == 'OppActive') ? '':(dataKey[i] == 'Inactive') ? '경쟁사 타겟':(dataKey[i] == 'CpaActive') ? '목표CPA':(dataKey[i] == 'all') ? '전체':(dataKey[i] == 'pc') ? 'PC':(dataKey[i] == 'mobile') ? 'Mobile':(dataKey[i] == 'null') ? '동기화요청':dataKey[i];
				html += "<li><input type='checkbox' id='"+ keyArray[str] + "-check" + i + "' data-key='" + dataKey[i] + "'" + checking + "><label for='"+ keyArray[str] + "-check" + i + "'>" + textFilter + "</label></li>";
			}
		}
		var listCheckType = function(i, type) {
			if(0 < filterKey.length) {
				for(var idx = 0; idx < filterKey.length; idx++) {
					if(filterKey[idx] == dataKey[i]) {
						listHtml(i, type, true);
						check = true;
						break;
					}
				}
			}
			if(0 === filterKey.length || check == false) {
				listHtml(i, type, false);
			}
		}


		if(key == 'status' || key == 'bid_status_a' || key == 'bid_status_b' || key == 'bid_status_c' || key == 'resv_status') {
			var types = (key == 'status') ? 'PAUSED':(key == 'bid_status_a') ? 'Active':(key == 'bid_status_b') ? 'CpaActive':(key == 'bid_status_c') ? 'OppActive':'Active';
			var str = (key == 'status') ? 0:(key == 'bid_status_a') ? 5:(key == 'bid_status_b') ? 6:(key == 'bid_status_c') ? 7:8;
			for(var i = 0; i < dataKey.length; i++) {
				listCheckType(i, types);
			}
			$(ulArray[str]).html(html);
		}else{
			for(var str = 0; str < keyArray.length; str++) {
				if(key == keyArray[str]) {
					for(var i = 0; i < dataKey.length; i++) {
						listCheckType(i, 'All');
					}
					$(ulArray[str]).html(html);
				}
			}
		}


	},

	//즐겨찾기 테이블 제어 이벤트
	favoriteFilterEvent:function(type, thisEl, allType) {
		var $this = $(thisEl);
		var $list = $('#bid-list-body-1');
		var $list2 = $('#bid-list-body-2');
		var checkLength = $this.find('li').find('input:checked').length;
		if(allType == true || 0 === checkLength) {
			$list.find('tr').removeClass('hide');
			$list2.find('tr').removeClass('hide');
			filterCheckSave = {};
		}else{
			$list.find('tr').addClass('hide');
			$list2.find('tr').addClass('hide');
			$this.find('li input').each(function(index) {
				var check = $(this).prop('checked');
				if(check == true) {
					var value = $(this).attr('data-key');
					var checkData = tableFilterData['data'][value];
					if(0 < checkData.length) {
						for(var i = 0; i < checkData.length; i++) {
							$list.find('.' + checkData[i]).removeClass('hide');
							$list2.find('.' + checkData[i]).removeClass('hide');
							filterCheckSave[value] = checkData[i];
						}
					}else{
						if(tableFilterData['key'] == 'status') {
							$list.find('tr').removeClass('hide');
							$list2.find('tr').removeClass('hide');
						}else{
							alert('관련 리스트를 찾을 수 없습니다.');
						}
					}
				}
			});
		}
		$('.all_view').removeClass('active').hide();
	},

	//최대 입찰가 일괄설정 콟백
	favoriteBidSetPopCallBack1:function(data, checkData) {
		favoriteFunc.favoriteBtnOnOffEvent();
		favoriteFunc.favoriteBidSetPopCallBack();
		favoriteFunc.favoriteBidSetData('view', 'bidSet');
	},
	//CPA 일괄설정 콜백
	favoriteBidSetPopCallBack2:function(data, checkData) {
		favoriteFunc.favoriteBtnOnOffEvent();
		favoriteFunc.favoriteBidCpaPopCallBack();
		favoriteFunc.favoriteBidSetData('view', 'bidCpa');
	},
	//경쟁사 타겟 일괄설정 콜백
	favoriteBidSetPopCallBack3:function(data, checkData) {
		favoriteFunc.favoriteBtnOnOffEvent();
		favoriteFunc.favoriteBidCpaPopCallBack();
		favoriteFunc.favoriteBidSetData('view', 'bidOpp');
	},
	favoriteTargetCallBack:function(data, checkData) {
		var keywords = faListData[data];
		var targetUrl = keywords['opp_site'];
		var targetGap = keywords['opp_gap'];
		var targetRank = keywords['opp_goal_rank'];

		$('#bid-set-save').attr('data-id', data);
		$('#target-url').val(targetUrl);

		$('#target-gap option').each(function() {
			var $this = $(this);
			var thisVal = $this.val();
			if(thisVal == targetGap) {
				$this.prop('selected', true);
			}
		});

		$('#target-rank option').each(function() {
			var $this = $(this);
			var thisVal = $this.val();
			if(thisVal == targetRank) {
				$this.prop('selected', true);
			}
		});

	},

	favoriteRateCallBack:function(data, checkData) {
		var data = data.data;
		var eachs = function(el, data) {
			if(data !== null) {
				var newData = {}
				var keys = Object.keys(data)
				for(var i=0; i<keys.length; i++) {
					newData[i+1] = data[keys[i]]
				}

				$(el).each(function(i) {
					var value = 0;
					if(0 < i) {
						value = !newData[i] ? 0 : newData[i];
					}
					$(this).find('input').val(value);
				});
			}else{
				$(el).each(function(i) {
					if(0 < i) {
						$(this).find('input').val(0);
					}
				});
			}
		}
		if(checkData !== 'change') {
			$('#rate-type select option').each(function() {
				var check = $(this).val();
				if(check == data.type) {
					$(this).prop('selected', true);
				}
			});
			if(data.type !== 'pct') {
				$('.default-btn').hide();
			}else{
				$('.default-btn').show();
			}
		}
		//증액
		eachs('.rate-table-list tbody .inc td',JSON.parse(data.increse_json));
		//감액
		eachs('.rate-table-list tbody .dec td',JSON.parse(data.decrese_json));

	},

	//키워드 예약 일괄 설정 콜백
	favoriteBidSetPopCallBack5:function(data) {
		bidScheAllData = data.data.bid_schedules;
		var scheKwd = Object.keys(bidScheAllData);

		var $this = $('#bid-list-body-1');
		var $list2 = $('#bid-list-body-2');
		var $addList = $('#add-key-list');
		var keywordList = [];


		var checkKwdList = function() {
			var html = '';
			$this.find('tr').each(function() {
				var $this = $(this);
				var kwdId = $this.attr('data-id');
				var $this2 = $list2.find('.' + kwdId);
				var checklist = faListData[kwdId];
				var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
				var check = $this.find("input[type='checkbox']").prop('checked');
				if(check == true && bidStatusCheck != 'Inactive') {
					keywordList.push(checklist);
				}
			});
			for(var i = 0; i < keywordList.length; i++) {
				html += "<li class='keyword-p' data-kwd='" + keywordList[i].kwd_id + "'><span>" + keywordList[i].kwd_nm + '</span><button type="button" onclick="favoriteFunc.favoriteSetEvent5(this, \'remove\');">X<button></li>';
			}
			$addList.append(html);
		};

		var scheList = function() {
			var $keyList = $('#all-key-list');
			var keywordSample = '';
			for(var i = 0; i < scheKwd.length; i++) {
				var kwdKey = scheKwd[i];
				var kwdName = faListData[kwdKey].kwd_nm;
				keywordSample += '<li><a href="javascript:void(0);" data-kwd="' + kwdKey + '" onclick="favoriteFunc.favoriteSetEvent5(this, \'add\');">' + kwdName + '</a></li>';
			}
			$keyList.html(keywordSample);
		}
		//키워드 리스트 실행
		scheList();
		checkKwdList();



		//예약 데이터 기반 UI 컨트롤
		favoriteFunc.bookingUi();
	},
	favoriteBidSetPopCallBack6:function(data, type) {

		var $this = $('#bid-list-body-1');
		var $list2 = $('#bid-list-body-2');
		var $addList = $('#add-key-list');
		var keywordList = [];

		var checkKwdList = function() {
			var html = '';
			$this.find('tr').each(function() {
				var $this = $(this);
				var kwdId = $this.attr('data-id');
				var $this2 = $list2.find('.' + kwdId);
				var checklist = faListData[kwdId];
				var bidStatusCheck = $this.find('.bidStatus-td > p').attr('data-status');
				var check = $this.find("input[type='checkbox']").prop('checked');
				if(check == true && bidStatusCheck != 'Inactive') {
					keywordList.push(checklist);
				}
			});
			for(var i = 0; i < keywordList.length; i++) {
				html += "<li class='keyword-p' data-kwd='" + keywordList[i].kwd_id + "'><span>" + keywordList[i].kwd_nm + '</span><button type="button" onclick="favoriteFunc.favoriteSetEvent5(this, \'remove\');">X<button></li>';
			}
			$addList.append(html);
		};

		checkKwdList();
		favoriteFunc.favoriteBtnOnOffEvent();
	},
	favoriteChartCallBack:function(data, type) {
		var dataFilter = data.data;
		if(type == 'chart1') {
			dataFilter = dataFilter;

		}else{
			dataFilter = dataFilter;
		}

		if(typeof dataFilter.chart_data !== 'undefined') {
			chartDataCheck = true;
			chartUi.init(dataFilter, type);
		}else{
			//데이터가 없을경우 분기처리
			chartDataCheck = false;
		}


	},


	//예약 액션 UI Set
	favoriteBookingCallBack:function(data, kwdKey) {
		var dataFilter = data.data;
		var scheData = dataFilter.bid_schedules[kwdKey[0]].bid_schedule;
		var typeData = dataFilter.bid_schedules[kwdKey[0]].bid_schedule_types;
		var deviceCheck = faListData[kwdKey].target;
		//예약 데이터 기반 UI 컨트롤
		favoriteFunc.bookingUi(scheData);
        dragChart.init(typeData, deviceCheck);
	},
	//예약 키워드 추가 이벤트
	favoriteSetEvent5:function(thisEl, Type) {
		var $this = $(thisEl);
		var $addList = $('#all-key-list');
		var html = '';
		if(Type == 'add') {
			var clickKwd = $this.attr('data-kwd');
			var clickSchedule = bidScheAllData[clickKwd].bid_schedule;
			var clickScheduleTypes = bidScheAllData[clickKwd].bid_schedule_types;
			bidScheAllClickKwd = clickKwd;
			$addList.find('a').removeClass('on');
			$this.addClass('on');
			//예약 데이터 기반 UI 컨트롤
			favoriteFunc.bookingUi(clickSchedule, clickScheduleTypes);
		}else if(Type == 'remove') {
			$this.parents('.keyword-p').remove();
		}
	},
	bookingUi:function(data, hoverTypes) {

		var sampleData = {};
		var chartId = $('#drag-graph-box');
        var gridBoxEl = chartId.find('.grid-box');
        var $xBox = $('.x-name-box');
        var $yBox = $('.y-name-box');
		var gridBox = '';
		var xyGridBox = '';
		var yBox = '';
		var xBox = '';
		var yArray = ['월','화','수','목','금','토','일'];


		//호버 말풍선 기능
		var schedulehoverSetting = function() {
			var data = hoverTypes;
			$('.grid-box .box-grid').mouseenter(function() {
				var $this = $(this);
				var thisColor = $this.attr('data-color');
				var commentUi = '';
				if(thisColor != 0) {
					if(typeof thisColor === 'string') {
						var thisData = data[thisColor];
						var thisType = thisData.bid_status;
						//코멘트 풍선
						commentUi += "<div class='comment-ui'>";
						if(thisType == 'Active') {
							commentUi += "<p class='comment-p'><strong>목표순위 자동입찰</strong></p>";
							commentUi += "<p class='comment-p'><strong>목표순위 : " + thisData.goal_rank + "</strong></p>";
							commentUi += "<p class='comment-p'><strong>최대 입찰가 : " + numberWithCommas(thisData.max_bid_amt) + "</strong></p>";
							commentUi += "<p class='comment-p'><strong>최소 입찰가 : " + numberWithCommas(thisData.min_bid_amt) + "</strong></p>";
						}else{
							commentUi += "<p class='comment-p'><strong>목표CPA 자동입찰</strong></p>";
							commentUi += "<p class='comment-p'><strong>목표CPA : " + numberWithCommas(thisData.goal_cpa) + "</strong></p>";
							commentUi += "<p class='comment-p'><strong>최대 입찰가 : " + numberWithCommas(thisData.max_bid_amt) + "</strong></p>";
							commentUi += "<p class='comment-p'><strong>최소 입찰가 : " + numberWithCommas(thisData.min_bid_amt) + "</strong></p>";
						}
						commentUi += "</div>";

					}
					$this.html(commentUi);
				}
			}).mouseleave(function() {
				$('.grid-box .box-grid > *').remove();
			});
		};


		//그리드 데이터
		var gridData = function() {
			if(data != null) {
				var dataSplit = data.split(',');
				var returnData = [];
				var x = 0;
				var y = 0;
				for(var i = 0; i < dataSplit.length; i++) {
					$('.grid-box .box-grid-line' + y + ' .grid-' + x).addClass('active active-' + dataSplit[i]).attr('data-color', dataSplit[i]);
					x++;
					if(x == 24) {
						y++;
						x = 0;
					}
				}
			}
		};

		//x축 grid
		for (var i = 0; i < 24; i++) {
            xBox += "<p class='x-grid x-" + i + "' data-x='" + i + "'>" + i + "</p>";
        }
        //y축 grid
        for (var i = 0; i < 7; i++) {
            yBox += "<p class='y-grid y-" + i + "' data-y='" + i + "'>" + yArray[i] + "</p>";
        }
        $xBox.html(xBox);
        $yBox.html(yBox);

        //x,y grid
        for (var i = 0; i < 24; i++) {
            gridBox += "<p class='box-grid grid-" + i + "' data-x='" + i + "' data-color=''></p>";
        }
        for (var i = 0; i < 7; i++) {
        	xyGridBox += "<div class='box-line box-grid-line" + i + "' data-y='" + i + "'>" + gridBox + "</div>";
        }
        gridBoxEl.html(xyGridBox);

   		//데이터 반영 그리드
        gridData();
        //일괄설정 스케줄 호버기능 온
        if(hoverTypes != undefined) {
	        schedulehoverSetting();
	    }

	},

















	//즐겨찾기 입찰가 일괄변경 팝업 콜백
	favoriteBidAllChangePopUpCallBack:function(data, checkData) {
		var $list = $('#bid_amt_preview_table tbody');
		var keywordHtml = '';
		if(0 < checkData.length) {
			for(var i = 0; i < checkData.length; i++) {
				keywordHtml += "<tr class='" + checkData[i].kwd_id + "' data-id='" + checkData[i].kwd_id + "' data-key='" + checkData[i].kwd_id + "'>";
				keywordHtml += '	<td>';
				keywordHtml += '		<div>';
				keywordHtml += '			<a href="https://search.naver.com/search.naver?query='+ checkData[i].kwd_nm +'" target="_blank"><button><img src="/image/common/keyword_icon.png" alt="돋보기버튼"></button></a>';
				keywordHtml += '		</div>';
				keywordHtml += '		<div>'+ checkData[i].kwd_nm +'</div>';
				keywordHtml += '	</td>';
				keywordHtml += '	<td>';
				keywordHtml += '		<div><input type="text" value="'+ numberWithCommas(checkData[i].cur_bid_amt) +'" readonly></div>';
				keywordHtml += '	</td>';
				keywordHtml += '	<td data-kwd_id="'+ checkData[i].kwd_id +'">';
				keywordHtml += 		"<div class='bid_wrap'>";
				keywordHtml += 			"<div class='bid_icon'>";
				keywordHtml += 				 "<button type='button' class='bid_02 list-btn-modify bid-cur-option'></button>";
				keywordHtml += 			"</div>";
				keywordHtml += 			"<div class='bid_price'>" + numberWithCommas(checkData[i].cur_bid_amt) + "</div>";
				keywordHtml += 			"<div class='active-btn-area hide'>";
				var curBtnId = '"#bid-save-btn-' + i + '"';
				keywordHtml += 				"<form onsubmit='favoriteFunc.favoriteBidChangeData(" + curBtnId +");'>";
				keywordHtml +=				"<button type='button' id='bid-save-btn'" + i + "' data-type='curBid' onclick='favoriteFunc.favoriteBidChangeData(this);' class='list-btn-save'>저장</button>";
				keywordHtml += 				"<button type='button' class='list-btn-cancer'>취소</button>";
				keywordHtml += 				"<input type='number' name='cur_bid_amt' data-type='curBid' value='" + checkData[i].cur_bid_amt + "' class='bid-cur-input active-input-area'>";
				keywordHtml += 			"</div>";
				keywordHtml += 		"</div>";
				keywordHtml += '	</td>';
				keywordHtml += '</tr>';
				bidChangeList[checkData[i].kwd_id] = checkData[i];
			}
		}
		$list.html(keywordHtml);
		var fixedEl = '.fixed-pop';
		$(fixedEl).fadeIn(200);
		$(fixedEl).find('.list-btn-modify').click(function() {
			var $this = $(this);
			$(fixedEl).find('.bid_icon').show();
			$(fixedEl).find('.bid_price').show();
			$(fixedEl).find('.active-btn-area').hide();
			$this.parent().hide();
			$this.parent().next().hide();
			$this.parent().parent().find('.active-btn-area').show();
		});
		$(fixedEl).find('.list-btn-cancer').click(function() {
			var $this = $(this);
			var prevText = $this.parent().parent().find('.bid_price').text();

			$(fixedEl).find('.bid_icon').show();
			$(fixedEl).find('.bid_price').show();
			$(fixedEl).find('.active-btn-area').hide();
			$this.parent().parent().find('.active-input-area').val(uncomma(prevText));
		});
		favoriteFunc.favoriteBidOptionEvent();
	},

	//즐겨찾기 팝업 옵션 이벤트
	favoriteBidOptionEvent:function() {
		var optionCheck = $('#choice1').prop('checked');
		if(optionCheck == true) {
			$('#option, #option-max-bid-amt').prop('checked', false).prop('disabled', true);
		}else{
			$('#option, #option-max-bid-amt').prop('disabled', false);
		}
	},

	//입찰가 일괄변경 미리보기
	clickBidAmtPreviewBtn : function(){
		var $radio = $('.amt-choices:checked');
		var $table = $('#bid_amt_preview_table');
		var $parentLi = $radio.closest('li');
		var changeValue = Number($parentLi.find('.change-value').val());
		var changeValueType = $parentLi.find('.change-value-type').val();
		var selectValue = $parentLi.find('.select-value').val();
		var optionCheck = $('#option').prop('checked');

		if( changeValue == '' ){
			alert('입찰가를 입력해주세요.');
			return;
		}

		switch($radio.val()){
			case 'SAME' :
				$table.find('tbody tr').each(function() {
					var dataKey = $(this).attr('data-key');

					if(optionCheck == true) {
						var maxAmt = $('#option-max-bid-amt').val();
						if(maxAmt < changeValue) {
							changeValue = maxAmt;
						}
					}
					changeValue = favoriteFunc.bidAmtRound(Number(changeValue));
					$(this).find('.bid_price').text(numberWithCommas(changeValue));
				});
				break;
			case 'INCREASE' :
				$table.find('tbody tr').each(function() {
					var dataKey = $(this).attr('data-key');
					if(changeValueType == '원') {
						var values = bidChangeList[dataKey].cur_bid_amt + changeValue;
					}else{
						var values =bidChangeList[dataKey].cur_bid_amt * (1+changeValue/100);
					}

					if(optionCheck == true) {
						var maxAmt = $('#option-max-bid-amt').val();
						if(maxAmt < values) {
							values = maxAmt;
						}
					}
					var price = favoriteFunc.bidAmtRound(Number(values));

					$(this).find('.bid_price').text(numberWithCommas(price));
				});
				break;
			case 'DECREASE' :
				$table.find('tbody tr').each(function() {
					var dataKey = $(this).attr('data-key');

					if(changeValueType == '원') {
						var values = bidChangeList[dataKey].cur_bid_amt - changeValue;
					}else{
						var values =bidChangeList[dataKey].cur_bid_amt * (1-changeValue/100);
					}

					if(optionCheck == true) {
						var maxAmt = $('#option-max-bid-amt').val();
						if(maxAmt < values) {
							values = maxAmt;
						}
					}
					var price = favoriteFunc.bidAmtRound(Number(values));

					$(this).find('.bid_price').text(numberWithCommas(price));
				});
				break;
			case 'MID_AMT' :
			case 'AVG_AMT' :
					var params = '?na_customer=' + advKey;
							params +='&view_bid_type=' + selectValue;
							params +='&na_kwd_sers=' + favoriteFunc.makeCheckedBiddingListKeywordKeyCommaStr(bidChangeList);
					var dataApi = dataUrl.biddingAPI('GET', 'NaverApiAmt', params);
					AjaxLoading.pageLoading();
					ajaxFrame.ajaxDataCall('GET', dataApi, 'json', true, favoriteFunc.setCurBidAmtByNaverAPI);
				break;
		}
		$table.find('tbody tr').find('.bid_price').addClass('effect');
		setTimeout(function() {
			$table.find('tbody tr').find('.bid_price').removeClass('effect');
		}, 500);
	},

	//입찰가 일괄변경 배열 담기
	makeCheckedBiddingListKeywordKeyCommaStr : function(checkedBiddingList){
		var na_kwd_sers = '';
		for(var key in checkedBiddingList){
			na_kwd_sers += key + ',';
		}
		na_kwd_sers = na_kwd_sers.substring(0, na_kwd_sers.length-1);
		return na_kwd_sers;
	},

	//입찰가 일괄변경 데이터 저장
	setCurBidAmtByNaverSaveAPI:function(result) {
		naverSaveAPIData = result.data;
	},

	//입찰가 일괄변경 기능
	setCurBidAmtByNaverAPI : function(result){
		var midAmts = result.data;
		var $table = $('#bid_amt_preview_table');
		var optionCheck = $('#option').prop('checked');
		var maxAmt = 0;
		var calcValue = 0;
		for(var kwdId in midAmts){
			calcValue = midAmts[kwdId].bid;
			calcValue = (OPTION_MAX_BID_AMT < calcValue ? OPTION_MAX_BID_AMT : calcValue);
			if(optionCheck == true) {
				maxAmt = $('#option-max-bid-amt').val();
				if(maxAmt < calcValue) {
					calcValue = favoriteFunc.bidAmtRound(maxAmt);
				}
			}
			$table.find('tbody .' + kwdId).find('.bid_price').text(numberWithCommas(favoriteFunc.bidAmtRound(calcValue)) );
		}
	},

	//즐겨찾기 동기화 콜백
	favoriteNaSyncCallBack:function(data) {
		setTimeout(function() {
			favoriteFunc.favoriteSubListData(advSubId, 'sync');
			$('#timeLoading').remove();
		}, 2000);
	},

	//즐겨찾기 일괄설정 미리보기 디세이블처리
	favoriteBidSetPopCallBack:function() {
		$('#max-bid-input').bind('keydown', function() {
			var thisVal = $(this).val();
			if(thisVal != '') {
				$('.preview_btn button').prop('disabled',false);
			}else{
				$('.preview_btn button').prop('disabled',true);
			}
		});
	},
	//즐겨찾기 Cpa 일괄설정 미리보기 디세이블처리
	favoriteBidCpaPopCallBack:function() {
		$('#goal-cpa').bind('keydown', function() {
			var thisVal = $(this).val();
			if(thisVal != '') {
				$('.preview_btn button').prop('disabled',false);
			}else{
				$('.preview_btn button').prop('disabled',true);
			}
		});
	},

	//즐겨찾기 일괄설정 미리보기 콜백
	favoriteBidSetViewCallBack:function(data, checkData, changeData, setType) {
		var $list = $('#bid-set-list');
		var keywordHtml = '';
		if(0 < checkData.length) {
			for(var i = 0; i < checkData.length; i++) {
				keywordHtml += '<tr>';
				keywordHtml += '	<td class="keyword_section">';
				keywordHtml += '		<div>';
				keywordHtml += 		"<a href='https://search.naver.com/search.naver?&query=" + checkData[i].kwd_nm +"' target='_blank'><img src='image/common/keyword_icon.png' alt=''></a>";
				keywordHtml += '		</div>';
				keywordHtml += '		<div>'+ checkData[i].kwd_nm +'</div>';
				keywordHtml += '	</td>';
				if(setType == 'bidSet') {
					var before1 = checkData[i].goal_rank;
					var before2 = numberWithCommas(checkData[i].max_bid_amt);
					var after1 = changeData[0];
					var after2 = numberWithCommas(changeData[1]);
				}else if(setType == 'bidCpa') {
					var before1 = numberWithCommas(checkData[i].goal_cpa_amt);
					var before2 = numberWithCommas(checkData[i].max_bid_amt);
					var after1 = numberWithCommas(changeData[0]);
					var after2 = numberWithCommas(changeData[1]);
				}else{
					var before1 = checkData[i].opp_gap;
					var before2 = numberWithCommas(checkData[i].max_bid_amt);
					var after1 = changeData[0] + checkData[i].opp_gap;
					var after2 = numberWithCommas(changeData[1]);
				}
				keywordHtml += '	<td>' + before1 + '</td>';
				keywordHtml += '	<td>' + before2 + '</td>';
				keywordHtml += '	<td>' + after1 + '</td>';
				keywordHtml += '	<td>' + after2 + '</td>';
				keywordHtml += '</tr>';
			}
		}
		$list.html(keywordHtml);
	},

	//즐겨찾기 입찰가 일괄설정 저장 콜백
	favoriteBidSetSaveCallBack:function(data, checkData, changeData, setType) {
		bidSetList = checkData;
		bidSetChange = changeData;
		if(0 < checkData.length) {
			for(var i = 0; i < checkData.length; i++) {
				if(setType == 'bidSet') {
					bidSetSaveKeywordData[checkData[i].kwd_id] = {
						"ad_med_id" : "1",
						"goal_rank":bidSetChange[0],
						"max_bid_amt":bidSetChange[1],
						"min_bid_amt":bidSetChange[2]
					}
				}else if(setType == 'bidCpa') {
					bidCpaSaveKeywordData[checkData[i].kwd_id] = {
						"ad_med_id" : "1",
						"goal_cpa_amt":changeData[0],
						"max_bid_amt":changeData[1],
						"min_bid_amt":changeData[2]
					}
				}else{
					bidOppSaveKeywordData[checkData[i].kwd_id] = {
						"ad_med_id" : "1",
						"opp_site":changeData[3],
						"opp_gap":changeData[0],
						"opp_goal_rank":changeData[4],
						"max_bid_amt":changeData[1],
						"min_bid_amt":changeData[2]
					}
				}
			}
			favoriteFunc.favoriteBidChangeData('#bid-list-body-1', setType);
		}
	},

	//즐겨찾기 이력 팝업 콜백
	favoriteHistoryPopCallBack:function(data) {
		var dataFilter = data.data;
		var $list = $('#history-list');
		var html = "";
		var d = new Date();
		var yy = d.getFullYear();
		var mm = ((d.getMonth() + 1) < 10) ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
		var dd = (d.getDate() < 10) ? '0' + d.getDate() : d.getDate();
		var todayText = yy + '-' + mm + '-'  + dd;

		if(dataFilter != undefined) {
			if(0 < dataFilter.length) {
				for(var i = 0; i < dataFilter.length; i++) {
					html += "<tr>";
					html += 	"<td>" + dataFilter[i].type + "</td>";
					html += 	"<td>" + dataFilter[i].msg + "</td>";
					html += 	"<td>" + dataFilter[i].user_info + "</td>";
					html += 	"<td>" + dataFilter[i].updated_at + "</td>";
					html += "</tr>";
				}
			}
		}else{
			html += "<tr>";
			html += 	"<td class='none_search'>";
			html += 		"<div>최근 이력이 없습니다.</div>";
			html += 	"</td>";
			html+= "</tr>";
		}

		$list.html(html);
		$('#create-date').attr('placeholder',todayText +  '~' + todayText);
		$('.fixed-pop').fadeIn(200);
	},


	//최소 입찰가 설정
	bidAmtRound: function(value){
		var result = Math.floor(Math.round(Number(value)/10))*10;
		if( result < 70 ){
			result = 70;
		}
		return result;
	},

	//ADV키 변경
	setAdvKeyDirectly : function(naAccKey){
		advKey = naAccKey;
	},

	//즐겨찾기 기타 함수 콜백처리
	favoriteNoFunction:function() {

	}
}


window.favoriteFunc = favoriteFunc;



// WEBPACK FOOTER //
// ./js/controller/assets/sub/favoriteFunc.js